<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 09 14 / ODOO-5800 (заказ Игоря): географическая карта — территории значений ссылочного измерения
             (страны) красятся по мере (напр. средний DOS страны). wijmo FlexMap + GeoMapLayer (GeoJSON-ассет фронта,
             Natural Earth 110m, упрощённый); «рисованный» вид — сглаживание Chaikin + SVG-фильтр дрожания линии.
             Несколько мер: легенда-переключатель (чекбокс = какой показатель красит территории); наведение на страну —
             чекбокс отбора: клик добавляет/снимает страну в чипсе стола, Alt+клик — оставляет её единственной.
             Слой точек (субъекты кружочками внутри территории, размер = мера) и слой связей (кривые со стрелками между
             точками / территориями, толщина = мера) — SVG-оверлей поверх карты; кружок = такой же отбор по своему полю. -->
        <!-- mousemove/mouseleave — на общем контейнере карты и подписей: подпись-чекбокс под курсором иначе считалась выходом
             мыши с карты (соседний элемент) и сбрасывала наведение сразу после появления -->
        <div class="attr-geo-map" ref="attr_container" :id="'vueObj'+attr_id" v-visible="handleVisibility"
            @mousemove="onHostMove" @mouseleave="onHostLeave" @contextmenu="ctxMenu_mapNode"><!-- IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты): правая кнопка по узлу — окно легенды, вкладка Node -->
            <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): шестерёнка и легенда карты — островком, как кнопки масштаба внизу -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="corner-island corner-island-tr">
                <div class="attr-geomap-legend-btn button-1 p-2" v-if="measures.length" :class="{'attr-geomap-btn-on': legendPanelVisible}"
                    v-wjTooltip="legendPanelVisible ? t('Hide legend') : t('Show legend')" @click="legendPanelVisible = !legendPanelVisible" v-uiHelp="{ key: 'chart.map.legendBtn', state: () => (legendPanelVisible ? 'on' : 'off') }">
                    <i class="pi pi-tags"/>
                </div>
                <div class="attr-geomap-cog button-1 p-2" ref="cogButton" @click="onToggle_settings" v-uiHelp="'chart.map.cog'">
                    <i class="pi pi-cog"/>
                </div>
            </div>
            <!-- легенда-переключатель показателей: чекбокс = мера, которая красит территории (одна активная) -->
            <!-- IE 2026 09 16 (заказ Игоря): легенда карты — свободное окно, как у графика: телепорт в контейнер страницы, перетаскивание за
                 шапку (в пределах экрана), положение живёт между открытиями; по умолчанию — у правого верхнего угла карты под островком кнопок -->
            <Teleport :to="overlayPortal(legendPortal)"><!-- IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen) -->
            <div class="attr-geomap-panel attr-geomap-panel-tabbed" :class="{ 'attr-geomap-panel-wjtabs': legendTabPanel_on() }" v-if="legendPanelVisible && legendOwner_shown()" ref="legendPanel" :data-widget="WIDGET && WIDGET.id" :style="legendPanelStyle()">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="attr-geomap-panel-head" @mousedown="legendDragStart" v-uiHelp="'chart.map.legend.window'">
                    <i class="pi pi-times attr-geomap-panel-close" v-uiHelp="'chart.map.legend.close'" :title="t('Close')" @mousedown.stop @click.stop="legendPanelVisible = false"/>
                    <span>{{ t('Legend') }}</span>
                </div>
                <!-- IE 2026 09 16 / ODOO-5800 (заказ Игоря): две вкладки — Node: наведённый узел / связь / страна с данными; Legend: показатели, глифы, отбор.
                     Переключатели «Flow map: ants» и «Σ» из легенды убраны — это настройки виджета, они в форме шестерёнки (map_ants, map_ants_total) -->
                <!-- IE 2026 09 30 / ODOO-343341 (заказ Игоря: вкладки легенды карты на AttrTabPanel): вкладки — компонента AttrTabPanel (вкладки из props, как в окне легенды графика); выключатель fe.ux.mapLegendTabPanel = false — прежние <span> -->
                <div class="attr-geomap-panel-tabs" v-if="!legendTabPanel_on()" @mousedown.stop>
                    <span class="attr-geomap-panel-tab" :class="{'is-on': legendTab === 'node'}" @click="legendTab = 'node'" v-uiHelp="{ key: 'chart.map.legend.tabNode', state: () => (legendTab) }">{{ t('Node') }}</span>
                    <span class="attr-geomap-panel-tab" :class="{'is-on': legendTab === 'legend'}" @click="legendTab = 'legend'" v-uiHelp="{ key: 'chart.map.legend.tabLegend', state: () => (legendTab) }">{{ t('Legend') }}</span>
                </div>
                <component :is="legendTabPanel_on() ? 'AttrTabPanel' : 'GeoMapLegendPlain'" v-bind="legendTabsBind()" @local-select="legendTab_select">
                <template #tab-node>
                <template v-if="legendTab === 'node'">
                <div class="attr-geomap-panel-hover" v-if="legendHoverInfo" v-uiHelp="{ key: 'chart.map.legend.nodeBlock', state: () => (legendHover ? legendHover.kind : 'none') }">
                    <div class="attr-geomap-panel-hover-head">
                        <span class="attr-geomap-panel-hover-kind">{{ legendHoverInfo.kind }}</span>
                        <b class="attr-geomap-panel-hover-title" :title="legendHoverInfo.title">{{ legendHoverInfo.title }}</b>
                        <span class="attr-geomap-panel-hover-sub" v-if="legendHoverInfo.sub">{{ legendHoverInfo.sub }}</span>
                    </div>
                    <table class="attr-geomap-hover-table"><tbody>
                        <tr v-for="(r, i) in legendHoverInfo.rows" :key="i">
                            <td class="attr-geomap-hover-name" :title="r.title">{{ r.title }}</td>
                            <td class="attr-geomap-hover-val" :class="r.cls" :style="r.style" v-html="r.text"></td>
                            <td class="attr-geomap-hover-extra" :class="r.extra && r.extra.cls" :style="r.extra && r.extra.style"><template v-if="r.extra"><span class="attr-geomap-hover-xl">{{ r.extra.title }}</span><span v-html="r.extra.text"></span></template></td>
                        </tr>
                    </tbody></table>
                </div>
                <div class="attr-geomap-panel-hint" v-else>{{ t('Hover a country, node or link on the map') }}</div>
                </template>
                </template>
                <template #tab-legend>
                <template v-if="legendTab !== 'node'">
                <label class="attr-geomap-panel-row" v-for="m in measures" :key="m.binding" :class="{'is-active': m.binding === valueBinding}">
                    <input type="checkbox" :checked="m.binding === valueBinding" @change="setActiveMeasure(m.binding)" v-uiHelp="{ key: 'chart.map.legend.measure', state: () => (m.binding === valueBinding ? 'on' : 'off') }"/>
                    <span class="attr-geomap-panel-title">{{ m.title || m.binding }}</span>
                    <i class="attr-geomap-panel-bar" v-if="m.binding === valueBinding && scaleInfo" :style="{ background: scaleInfo.gradient }"></i>
                </label>
                <!-- IE 2026 09 17 / ODOO-… (заказ Игоря): что показывать на карте — связи, узлы, узлы поставок, раскраска стран -->
                <div class="attr-geomap-panel-show">
                    <label class="attr-geomap-panel-row" v-for="sw in showSwitches" :key="sw.key">
                        <input type="checkbox" :checked="sw.on" @change="showToggle(sw.key)" v-uiHelp="{ key: 'chart.map.legend.show.' + sw.key, state: () => (sw.on ? 'on' : 'off') }"/>
                        <span class="attr-geomap-panel-title">{{ sw.title }}</span>
                    </label>
                </div>
                <div class="attr-geomap-panel-foot" v-if="pointBinding && overlayPoints.length" v-uiHelp="'chart.map.legend.footPoints'">
                    <span class="attr-geomap-panel-dot"></span><span>{{ pointsTitle }}: {{ t('circle size = {title}', { title: pointSizeTitle }) }}<template v-if="pointRingTitle">, {{ t('ring = {title}', { title: pointRingTitle }) }}</template><template v-if="pointCoreTitle">, {{ t('red core = {title}', { title: pointCoreTitle }) }}</template></span><!-- IE 2026 09 15 (замечание Игоря): глиф точки -->
                </div>
                <div class="attr-geomap-panel-foot" v-if="linkFromBinding && overlayLinks.length" v-uiHelp="'chart.map.legend.footLinks'">
                    <span class="attr-geomap-panel-line" :style="{ background: linkColor }"></span><span>{{ t('links: width = {title}', { title: linkValueTitle }) }}<template v-if="linkUncBinding">; </template></span><template v-if="linkUncBinding"><span class="attr-geomap-panel-line" :style="{ background: uncColor }"></span><span>{{ t('red = {title}', { title: linkUncTitle }) }}</span></template>
                </div>
                <!-- IE 2026 09 16 (постановка Игоря): блок наведения — узел / связь / страна — теперь вкладка Node (выше) -->
                <div class="attr-geomap-panel-foot" v-if="selectedKeys.size || selectedPointKeys.size">
                    <span>{{ t('{n} selected', { n: selectedKeys.size + selectedPointKeys.size }) }}</span>
                    <a href="#" @click.prevent="clearSelection" v-uiHelp="'chart.map.legend.selected'">{{ t('clear') }}</a>
                </div>
                </template>
                </template>
                </component>
            </div>
            </Teleport>
            <div class="attr-geomap-empty" v-if="emptyMessage" v-uiHelp="'chart.map.empty'">{{ emptyMessage }}</div>
            <div :id="attr.html_id" class="attr-geomap-host" :class="{'attr-geomap-sketch': sketchOn}" ref="host" :style="{ background: seaColor }"
                v-wjContextMenu="'ContextWidgetMenuId'"></div>
            <!-- оверлей связей и точек: связи не ловят мышь, кружки — ловят (наведение, отбор) -->
            <svg class="attr-geomap-overlay" v-if="overlayLinks.length || overlayPoints.length" :width="overlaySize.w" :height="overlaySize.h">
                <defs>
                    <marker :id="'ie-geomap-arrow-' + attr_id" markerWidth="9" markerHeight="9" refX="8" refY="4.5" orient="auto" markerUnits="userSpaceOnUse">
                        <path d="M0,0.5 L9,4.5 L0,8.5 z" :fill="linkColor"/>
                    </marker>
                    <!-- IE 2026 09 16 (заказ Игоря): стрелка красной связи (непокрытый объём) -->
                    <marker :id="'ie-geomap-arrow-unc-' + attr_id" markerWidth="9" markerHeight="9" refX="8" refY="4.5" orient="auto" markerUnits="userSpaceOnUse">
                        <path d="M0,0.5 L9,4.5 L0,8.5 z" :fill="uncColor"/>
                    </marker>
                </defs>
                <path v-for="l in overlayLinks" :key="l.key" class="attr-geomap-link" v-uiHelp="{ key: 'chart.map.link', state: () => (l.unc ? 'uncovered' : 'covered') }" :d="l.d" :stroke="l.unc ? uncColor : linkColor" :stroke-width="l.w" fill="none"
                    :marker-end="'url(#ie-geomap-arrow-' + (l.unc ? 'unc-' : '') + attr_id + ')'" :class="{'is-dim': litPoints.size && !l.lit, 'is-lit': litPoints.size && l.lit, 'is-unc': l.unc, 'is-hover': hoverLink === l.key}"
                    @mouseenter="hoverLinkSet(l.key)" @mouseleave="hoverLinkSet(null)"/><!-- IE 2026 09 16 (постановка Игоря): наведение на связь — блок в легенде -->
                <!-- IE 2026 09 15 (замечание Игоря): глиф точки как у узлов «муравьиной логистики» — диск (мера размера), внешний круг (мера
                     кольца, напр. продажи) и красное ядро (напр. непокрытые продажи); при муравьях — значения месяца часов, радиусы плавно -->
                <g v-for="p in overlayPoints" :key="p.key" class="attr-geomap-pt" v-uiHelp="'chart.map.point'" :data-key="p.key"
                    :class="{'is-hover': hoverPoint === p.key, 'is-selected': selectedPointKeys.has(p.key), 'is-lit': litPoints.has(p.key), 'is-dim': litPoints.size && !litPoints.has(p.key)}"
                    @click.stop="onPointClick($event, p.key)">
                    <circle class="attr-geomap-point" :class="{'is-empty': p.emptyNow}" :cx="p.x" :cy="p.y" :r="p.r" :data-key="p.key" :fill="p.fill"/>
                    <!-- IE 2026 09 16 (постановка Игоря): второй круг узла — запас на НАЧАЛО периода (пунктир, цвет = состояние на начало); сплошной — на конец -->
                    <circle v-if="p.rStart > 0.5" class="attr-geomap-point-start" :cx="p.x" :cy="p.y" :r="p.rStart" :data-key="p.key" :stroke="p.strokeStart" fill="none" stroke-dasharray="3 2"/>
                    <circle v-if="p.rRing > 0.5" class="attr-geomap-point-ring" :cx="p.x" :cy="p.y" :r="p.rRing" :data-key="p.key"/>
                    <circle v-if="p.rCore > 0.5" class="attr-geomap-point-core" :cx="p.x" :cy="p.y" :r="p.rCore" :data-key="p.key"/>
                </g>
            </svg>
            <!-- IE 2026 09 15 / ODOO-… (замечание Игоря): муравьиная логистика на карте — частицы по дугам связей помесячно (общие часы страницы) -->
            <canvas v-if="antsOn && antsActive" ref="antCanvas" class="attr-geomap-ants" :width="Math.round(overlaySize.w * antDpr)" :height="Math.round(overlaySize.h * antDpr)" :style="{ width: overlaySize.w + 'px', height: overlaySize.h + 'px' }"></canvas>
            <!-- IE 2026 09 15 (замечание Игоря): плеер — над островком легенды шкалы цвета (оба в левом нижнем углу, плеер его накрывал) -->
            <AntPlayer v-if="antsOn && antClockObj && antsActive" :clock="antClockObj" :stats="antStats" :tick="antTick" :month="antMonth" :style="antPlayerStyle"/>
            <!-- подписи территорий: HTML поверх карты (чекбокс отбора + эмодзи-флаг + значение), позиции — по центроиду -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="attr-geomap-labels">
                <span v-for="l in labels" :key="l.key" class="attr-geomap-label" :data-key="l.key"
                    :class="{'is-hover': hoverKey === l.key, 'is-selected': selectedKeys.has(l.key), 'is-text': labelsOn}"
                    :style="{ left: l.x + 'px', top: l.y + 'px' }" @click.stop="onLabelClick($event, l.key)" v-uiHelp="{ key: 'chart.map.countryLabel', state: () => (selectedKeys.has(l.key) ? 'selected' : 'none') }"
                    v-show="labelShown(l)"><!-- IE 2026 09 14 / ODOO-… (замечание Игоря: бейджи, которым нет места): спрятанный бейдж — по наведению / отбору; IE 2026 09 18: при наведении — только бейдж наведённого элемента (labelShown) -->
                    <i class="attr-geomap-check" :class="selectedKeys.has(l.key) ? 'pi pi-check-square' : 'pi pi-stop'"
                        v-show="hoverKey === l.key || selectedKeys.has(l.key)"
                        v-wjTooltip="t('Click — add / remove the country in the selector, Alt+click — only this country')" v-uiHelp="{ key: 'chart.map.countryCheck', state: () => (selectedKeys.has(l.key) ? 'on' : 'off') }"></i>
                    <!-- IE 2026 09 16 (заказ Игоря: подписи при наведении): иконка открытия записи страны; показатели — DOS и состояние на начало, продажи за период | непокрытые -->
                    <i class="pi attr-geomap-open" :class="openIconFor(geoBinding, l.key)" v-show="hoverKey === l.key || selectedKeys.has(l.key)" :title="t('Open record')" @click.stop="openRecordFor(geoBinding, l.key)" v-uiHelp="'chart.map.openRecord'"></i>
                    <!-- IE 2026 09 16 / ODOO-5800 (заказ Игоря): при открытой легенде подпись наведения — только чекбокс, иконка, флаг и название (данные — во вкладке Node) -->
                    <template v-if="badgeCompact && hoverKey === l.key"><!-- IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): без Alt — флаг и название -->
                        <span class="attr-geomap-label-flag" v-if="l.flag">{{ l.flag }}</span><span class="attr-geomap-label-name" v-if="l.title">{{ l.title }}</span>
                    </template>
                    <template v-else-if="labelsOn">
                        <span class="attr-geomap-label-flag" v-if="l.flag">{{ l.flag }}</span><span class="attr-geomap-label-name" v-if="hoverKey === l.key && l.title">{{ l.title }}:&nbsp;</span><span class="attr-geomap-label-text" v-html="l.text"></span><!-- IE 2026 09 14 / ODOO-5800 (замечание Игоря): при наведении — и название территории -->
                    </template>
                    <span class="attr-geomap-badge-ext" :class="{ 'alt-details-fading': badgeDetailsFading }" :style="badgeFadeStyle" v-if="badgeDetailsOn && !(compactHover && hoverKey === l.key) && (hoverKey === l.key || selectedKeys.has(l.key)) && badgeCountry(l.key)" v-html="badgeCountry(l.key)"></span><!-- IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): меры — по Alt -->
                </span>
                <!-- подписи точек: при наведении / отборе — чекбокс, название, размер -->
                <span v-for="p in overlayPoints" :key="'p' + p.key" class="attr-geomap-label attr-geomap-plabel is-text" v-uiHelp="'chart.map.pointLabel'" :data-pkey="p.key"
                    :class="{'is-hover': hoverPoint === p.key, 'is-selected': selectedPointKeys.has(p.key)}"
                    :style="{ left: p.x + 'px', top: (p.y - p.rMax - 8) + 'px' }" @click.stop="onPointClick($event, p.key)"
                    v-show="plabelShown(p)">
                    <i class="attr-geomap-check" :class="selectedPointKeys.has(p.key) ? 'pi pi-check-square' : 'pi pi-stop'" v-uiHelp="{ key: 'chart.map.pointCheck', state: () => (selectedPointKeys.has(p.key) ? 'on' : 'off') }"
                        v-wjTooltip="t('Click — add / remove in the selector, Alt+click — only this one')"></i>
                    <i class="pi attr-geomap-open" :class="openIconFor(pointBindingFor(p.key), p.key)" :title="t('Open record')" @click.stop="openRecordFor(pointBindingFor(p.key), p.key)" v-uiHelp="'chart.map.openRecord'"></i><!-- IE 2026 09 16 (заказ Игоря): открыть запись -->
                    <span class="attr-geomap-label-text">{{ p.title }}<template v-if="!(badgeCompact && hoverPoint === p.key)">: <b v-html="p.text"></b></template></span><!-- IE 2026 09 16 / ODOO-5800 (заказ Игоря): при открытой легенде — только чекбокс, иконка и название -->
                    <span class="attr-geomap-badge-ext" :class="{ 'alt-details-fading': badgeDetailsFading }" :style="badgeFadeStyle" v-if="badgeDetailsOn && !(compactHover && hoverPoint === p.key) && badgePoint(p.key)" v-html="badgePoint(p.key)"></span><!-- IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): меры — по Alt -->
                </span>
                <!-- IE 2026 09 16 (заказ Игоря): подпись связи под курсором — два блока (узел с / узел на: чекбокс, иконка, название) и объём | непокрытый -->
                <span v-for="l in overlayLinks" :key="'l' + l.key" class="attr-geomap-label attr-geomap-llabel is-text is-hover" v-uiHelp="'chart.map.linkLabel'" :data-lkey="l.key"
                    :style="{ left: l.lx + 'px', top: l.ly + 'px' }" v-show="llabelShown(l)" @mouseenter="hoverLinkSet(l.key)" @mouseleave="hoverLinkSet(null)" @click.stop>
                    <template v-for="end in linkEnds(l.key)" :key="end.key">
                        <span class="attr-geomap-llabel-node">
                            <i class="attr-geomap-check" :class="end.selected ? 'pi pi-check-square' : 'pi pi-stop'" v-wjTooltip="t('Click — add / remove in the selector, Alt+click — only this one')" @click.stop="toggleSelectFor(end.binding, end.key, !!$event.altKey, end.kind)" v-uiHelp="{ key: 'chart.map.linkEndCheck', state: () => (end.selected ? 'on' : 'off') }"></i>
                            <i class="pi attr-geomap-open" :class="openIconFor(end.binding, end.key)" :title="t('Open record')" @click.stop="openRecordFor(end.binding, end.key)" v-uiHelp="'chart.map.openRecord'"></i>
                            <span class="attr-geomap-label-text">{{ end.title }}</span>
                        </span>
                        <span class="attr-geomap-llabel-arrow" v-if="end.kind !== 'to'">→</span>
                    </template>
                    <span class="attr-geomap-badge-ext" :class="{ 'alt-details-fading': badgeDetailsFading }" :style="badgeFadeStyle" v-if="badgeDetailsOn && !compactHover" v-html="badgeLink(l.key)"></span><!-- IE 2026 09 16 / ODOO-5800 (заказ Игоря): при открытой легенде — без объёмов -->
                </span>
            </div>
            <!-- нижняя полоса: легенда шкалы (градиент по палитре, подписи min / max компактно — 112K … 55M) и справа
                 кнопки масштаба + / − и «вписать в экран» (как на старте) — IE 2026 09 14 / ODOO-5800 (замечание Игоря):
                 кнопки wijmo из угла карты перенесены сюда -->
            <!-- IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): нижняя полоса не отнимает высоту у карты — легенда и кнопки лежат островками поверх неё -->
            <div class="attr-geomap-legend attr-geomap-island attr-geomap-island-legend" v-if="legendOn && scaleInfo" v-uiHelp="{ key: 'chart.map.scaleLegend', state: () => (scaleInfo.categories ? 'state' : (scaleInfo.single ? 'single' : 'scale')) }">
                <template v-if="legendOn && scaleInfo">
                    <span class="attr-geomap-legend-title">{{ valueTitle }}</span>
                    <template v-if="scaleInfo.categories"><!-- IE 2026 09 16 (постановка Игоря): состояние запаса — цветные категории -->
                        <span class="attr-geomap-legend-cat" v-for="c in scaleInfo.categories" :key="c.id"><i class="attr-geomap-legend-swatch" :style="{ background: c.color }"></i>{{ c.title }}</span>
                    </template>
                    <template v-else>
                    <span class="attr-geomap-legend-min" v-html="scaleInfo.minText"></span>
                    <i class="attr-geomap-legend-bar" :class="{ 'attr-geomap-legend-bar-single': scaleInfo.single }" :style="{ background: scaleInfo.gradient }"
                        :title="scaleInfo.single ? t('Single value — one neutral colour') : null"></i><!-- IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки) -->
                    <span class="attr-geomap-legend-max" v-if="!scaleInfo.single" v-html="scaleInfo.maxText"></span>
                    </template>
                </template>
            </div>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="attr-geomap-island attr-geomap-island-zoom">
                <span class="attr-geomap-zoom">
                    <span class="attr-geomap-zoombtn is-in" v-uiHelp="'chart.map.zoomIn'" v-wjTooltip="t('Zoom in')" @click="zoomBy(1)"><i class="pi pi-plus"/></span>
                    <span class="attr-geomap-zoombtn is-out" v-uiHelp="'chart.map.zoomOut'" v-wjTooltip="t('Zoom out')" @click="zoomBy(-1)"><i class="pi pi-minus"/></span>
                    <span class="attr-geomap-zoombtn is-fit" v-uiHelp="'chart.map.fit'" v-wjTooltip="t('Fit to view — territories with data, as at start')" @click="fitAndLabel()"><i class="pi ie-ico-fit"/></span><!-- иконка графа «Fit to view» (.pi.ie-ico-fit, глобальный стиль AttrGraph) -->
                </span>
            </div>
        </div>
    </Attr>
</template>

<script>
import AntPlayer from './AntPlayer.vue'
import { overlayPortal } from '@/utils/overlayRoot'   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): цель телепорта окна легенды
import { legendOwnerMixin } from '@/utils/legendOwner'   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
// IE 2026 09 15 / ODOO-… (замечание Игоря): муравьиная логистика на карте — частицы по дугам связей, общие часы страницы
import { antClock, antClockJoin, antClockLeave, antClockTick, antClockSig, antMonthKey, antClockSyncPeriod, antClockStartMode, antClockTotal } from '../../../utils/antClock'   // IE 2026 09 16: стартовый режим Σ
import { AntRunner, antHex, quadAt } from '../../../utils/antRunner'
import { stableBoxApply, stableBoxReset } from '@/utils/stableBox'   // IE 2026 09 17 / ODOO-… (замечание Игоря): окно легенды не прыгает по размеру
import { useMainStore } from '@/stores/mainStore'
import { ctxMenu_allowed, ctxMenu_count } from '@/utils/ctxMenuGuard'   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
import { t } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n
import altTooltip from '@/utils/altTooltip'   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): бейджи карты: меры — по Alt (detailsOn)
import { uiHelp_html, uiHelp_enabled } from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt): chart.map.territory — источник «по точке»
import { Rect } from '@mescius/wijmo'   // U6: подсказка территории — у курсора
import { markRaw } from 'vue'
import { Point, Color } from '@mescius/wijmo'
import { FlexMap, GeoMapLayer } from '@mescius/wijmo.chart.map'

// IE 2026 09 14 / ODOO-5800: палитра по умолчанию — от дефицита (красный) через норму (жёлтый) к избытку (зелёный)
const DEFAULT_COLORS = ['#e57373', '#ffd54f', '#81c784']
const DEFAULT_SEA = '#e3f4fb'
const DEFAULT_EMPTY = '#ffffff'
const OUTLINE = '#2f3b52'
const OUTLINE_SELECTED = '#1a237e'
const DEFAULT_LINK = '#3d6fd1'   // IE 2026 09 16 (замечание Игоря): связи — синие, красный (UNC_COLOR) только у непокрытых; раньше оранжевый читался как красный
const POINT_FILL = '#3949ab'
const SCATTER_COLOR = '#2e9e6b'   // IE 2026 09 15 (заказ Игоря: цепочка на карте): муравьи продаж, разбегающиеся от узла
const UNC_COLOR = '#d9534f'   // IE 2026 09 16 (заказ Игоря): непокрытые объёмы — красные связи, муравьи и разбегание (как красное ядро узла)
// IE 2026 09 16 (постановка Игоря: легенда карты): состояния запаса (open_balance_category витрины MV::CALC::Balance) — цвет, подпись и
// ранг «хуже» (итог страны = худшее состояние её узлов); страны красятся состоянием при активной мере DOS, узлы — своим состоянием
// IE 2026 09 16 / ODOO-5800 (заказ Игоря): те же подписи и цвета, что у «Stock state» в отчётах Purchase — подписи = справочник
// GRADE (OOS / Low / High / Optimal / OK / No sales), цвета = классы оформления шаблона Purchase KPI (критично/нет продаж — красный,
// min — оранжевый, opt — жёлтый, ok — светло-голубой, max — зелёный); ранг «хуже» = шкала агрегата Scale отчёта
// (oos, min, max, opt, ok, no_sales), состояния вне шкалы (dead, actualized) — в хвосте
// IE 2026 09 18 (заказ Игоря: «цвета раскраски фонов от категории запасов — такие же, как в таблицах, везде одинаковые»):
// color — насыщенный цвет МЕТОК (кружки узлов, обводки); фон (территории, свотчи легенды, ячейки и пилюли блока наведения) —
// цвет класса условного оформления таблиц cls (cell-background-*, см. stateBg): bg — запасное значение, fg — цвет текста на фоне
// IE 2026 10 01 / ODOO-5800 (Igor 01.10: сверхнормативная зона политики запасов): excess — выше порога excess правила (категория движка excess, LS 6): синий
// stock-excess таблиц; ранг — между min и max (как GRADE_ORDER бэка: «сверхнорматив» важнее max, «ниже min» важнее сверхнорматива); max — max…excess (зелёный, как был)
const STATE_META = {
    oos:        { title: 'OOS',              color: '#c62828', rank: 0, cls: 'cell-background-red',    bg: '#ff8a8a', fg: '#ffffff' },
    min:        { title: 'Low',              color: '#ef6c00', rank: 1, cls: 'cell-background-orange', bg: '#ffdede' },
    excess:     { title: 'Excess',           color: '#1e88e5', rank: 1.5, cls: 'cell-background-blue-strong', bg: '#a0c4ff', fg: '#0f2d66' },
    max:        { title: 'High',             color: '#2e7d32', rank: 2, cls: 'cell-background-green',  bg: '#dfedde' },
    opt:        { title: 'Optimal',          color: '#f9a825', rank: 3, cls: 'cell-background-yellow', bg: '#fff2de' },
    ok:         { title: 'OK',               color: '#64b5f6', rank: 4, cls: 'cell-background-blue',   bg: '#dde9f7' },   // в таблицах ok — белый, голубой — для карт и графов
    no_sales:   { title: 'No sales',         color: '#c62828', rank: 5 },
    dead:       { title: 'No sales (stock)', color: '#455a64', rank: 6 },
    actualized: { title: 'Actualized',       color: '#00838f', rank: 7 },
}
const stateMeta = (s) => STATE_META[String(s || '').trim()] || null
// IE 2026 09 23 / ODOO-341407: i18n: подпись состояния — через словарь (ключ — английская подпись STATE_META); вызывать из методов (словарь грузится после импорта модуля)
const STATE_TITLE = { oos: () => t('OOS'), min: () => t('Low'), excess: () => t('Excess'), max: () => t('High'), opt: () => t('Optimal'), ok: () => t('OK'), no_sales: () => t('No sales'), dead: () => t('No sales (stock)'), actualized: () => t('Actualized') }   // IE 2026 10 01 / ODOO-5800: + excess
const stateTitle = (s) => { const id = String(s || '').trim(); return STATE_TITLE[id] ? STATE_TITLE[id]() : (STATE_META[id]?.title || '') }
// фон категории запаса: цвет берём У КЛАССА таблиц (один источник правды — сменят цвет класса, карта пойдёт следом);
// стили грида могут быть ещё не загружены или класс переопределён прозрачным — тогда запасное значение bg
// IE 2026 09 18 / ODOO-… (заказ Игоря: именованные стили): сначала — семантический стиль сегмента CSS-CLASS
// (Stock · Critical / Low / Optimal / Normal / High): его цвет для карт map_color либо фон зарегистрированного класса;
// затем — класс таблиц cls; затем запасное значение
const STATE_STYLE = { oos: 'stock-critical', min: 'stock-min', opt: 'stock-opt', ok: 'stock-ok', max: 'stock-max', excess: 'stock-excess' }   // IE 2026 10 01 / ODOO-5800: + excess
let _stateBgCache = {}
let _stateStyles = null   // реестр store.cssClasses (ставит компонент карты)
function classBg(cls) {
    if (!cls || typeof document === 'undefined' || !document.body) return ''
    try {
        const el = document.createElement('div')
        el.className = 'wj-cell ' + cls
        el.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;pointer-events:none'
        document.body.appendChild(el)
        const c = getComputedStyle(el).backgroundColor
        el.remove()
        return (c && c !== 'transparent' && !/rgba\([^)]*,\s*0\s*\)/.test(c) && c !== 'rgb(255, 255, 255)') ? c : ''
    } catch (e) { return '' }
}
function stateBg(s) {
    const id = String(s || '').trim(), m = STATE_META[id]
    if (!m) return null
    if (_stateBgCache[id]) return _stateBgCache[id]
    const sem = STATE_STYLE[id], reg = sem && _stateStyles ? _stateStyles[sem] : null
    const col = String(reg?.map_color || '').trim() || (reg ? classBg(reg.name || sem) : '') || classBg(m.cls)
    if (col) _stateBgCache[id] = col   // запасное значение не кэшируем: стили могут подгрузиться позже
    return col || m.bg || m.color
}
const stateFg = (s) => (stateMeta(s) || {}).fg || '#37474f'
const worseState = (a, b) => { const ma = stateMeta(a), mb = stateMeta(b); if (!ma) return mb ? b : (a || b || ''); if (!mb) return a; return ma.rank <= mb.rank ? a : b }
const POINT_MIN_R = 4
// названия стран из 1С, отличные от русских названий Natural Earth (name_ru) — код ISO для сопоставления
const NAME_ISO = {
    'китай': 'CN', 'кнр': 'CN', 'корея': 'KR', 'южная корея': 'KR', 'республика корея': 'KR', 'республика македония': 'MK',
    'северная македония': 'MK', 'македония': 'MK', 'молдова': 'MD', 'беларусь': 'BY', 'кыргызстан': 'KG', 'туркменистан': 'TM',
    'сша': 'US', 'соединённые штаты америки': 'US', 'соединенные штаты америки': 'US', 'великобритания': 'GB', 'англия': 'GB',
    'россия': 'RU', 'российская федерация': 'RU', 'чехия': 'CZ', 'чешская республика': 'CZ', 'словакия': 'SK', 'нидерланды': 'NL',
    'голландия': 'NL', 'оаэ': 'AE', 'объединённые арабские эмираты': 'AE', 'вьетнам': 'VN', 'тайвань': 'TW', 'гонконг': 'HK',
    'иран': 'IR', 'сирия': 'SY', 'лаос': 'LA', 'босния и герцеговина': 'BA', 'сербия': 'RS', 'косово': 'XK', 'грузия': 'GE',
}

// эмодзи-флаг → ISO 3166-1 alpha-2 (региональные индикаторы U+1F1E6…U+1F1FF = A…Z)
function flagToIso(flag) {
    if (!flag) return ''
    const letters = [...String(flag)]
        .map(ch => ch.codePointAt(0))
        .filter(cp => cp >= 0x1F1E6 && cp <= 0x1F1FF)
        .map(cp => String.fromCharCode(cp - 0x1F1E6 + 65))
    return letters.length === 2 ? letters.join('') : ''
}

// IE 2026 09 14 / ODOO-5800 (замечание Игоря): ISO 3166-1 alpha-2 → эмодзи-флаг (обратно к flagToIso) — флаг для стран,
// у которых в справочнике флага нет (страны поставщиков): берётся из ISO территории ассета
function isoToFlag(iso) {
    const s = String(iso || '').toUpperCase()
    if (!/^[A-Z]{2}$/.test(s)) return ''
    return String.fromCodePoint(...[...s].map(ch => 0x1F1E6 + ch.charCodeAt(0) - 65))
}

// сглаживание Chaikin замкнутого кольца (первая точка = последняя): углы срезаются, контур становится «рисованным»
function chaikin(ring, iterations = 2) {
    let pts = ring.slice(0, ring.length - 1)
    if (pts.length < 4) return ring
    for (let it = 0; it < iterations; it++) {
        const out = []
        for (let i = 0; i < pts.length; i++) {
            const p = pts[i], q = pts[(i + 1) % pts.length]
            out.push([0.75 * p[0] + 0.25 * q[0], 0.75 * p[1] + 0.25 * q[1]])
            out.push([0.25 * p[0] + 0.75 * q[0], 0.25 * p[1] + 0.75 * q[1]])
        }
        pts = out
    }
    return [...pts, pts[0]]
}

function smoothGeometry(g) {
    if (!g) return g
    if (g.type === 'Polygon') return { type: 'Polygon', coordinates: g.coordinates.map(r => chaikin(r)) }
    if (g.type === 'MultiPolygon') return { type: 'MultiPolygon', coordinates: g.coordinates.map(poly => poly.map(r => chaikin(r))) }
    return g
}

// крупнейшее кольцо геометрии (для центроида и проверки «внутри»)
function mainRing(g) {
    const rings = g.type === 'Polygon' ? [g.coordinates[0]] : g.type === 'MultiPolygon' ? g.coordinates.map(p => p[0]) : []
    let best = null, bestArea = -1
    for (const r of rings) {
        let a = 0
        for (let i = 0; i < r.length - 1; i++) a += r[i][0] * r[i + 1][1] - r[i + 1][0] * r[i][1]
        const area = Math.abs(a) / 2
        if (area > bestArea) { bestArea = area; best = r }
    }
    return best
}

// центроид крупнейшего кольца (формула площади многоугольника) — точка подписи
function centroid(g) {
    const r = mainRing(g)
    if (!r) return null
    let a = 0, cx = 0, cy = 0
    for (let i = 0; i < r.length - 1; i++) {
        const f = r[i][0] * r[i + 1][1] - r[i + 1][0] * r[i][1]
        a += f; cx += (r[i][0] + r[i + 1][0]) * f; cy += (r[i][1] + r[i + 1][1]) * f
    }
    return a ? [cx / (3 * a), cy / (3 * a)] : null
}

function pointInRing(ring, x, y) {
    let inside = false
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const xi = ring[i][0], yi = ring[i][1], xj = ring[j][0], yj = ring[j][1]
        if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) inside = !inside
    }
    return inside
}

// цвет по доле шкалы 0…1 — кусочно-линейно между стопами палитры (ColorScale wijmo со сплайном требует ≥4 цветов,
// при трёх падает в _Spline.calculate — свой интерполятор проще и предсказуемее)
function paletteColor(colors, t) {
    const stops = colors.map(c => Color.fromString(c)).filter(Boolean)
    if (!stops.length) return '#999999'
    if (stops.length === 1) return stops[0].toString()
    t = Math.max(0, Math.min(1, Number.isFinite(t) ? t : 0))
    const pos = t * (stops.length - 1), i = Math.min(stops.length - 2, Math.floor(pos)), k = pos - i
    const a = stops[i], b = stops[i + 1]
    return Color.fromRgba(a.r + (b.r - a.r) * k, a.g + (b.g - a.g) * k, a.b + (b.b - a.b) * k, 1).toString()
}

// компактное число подписи на карте: 1.2M / 345K / 12
function compactNumber(v) {
    const a = Math.abs(v)
    if (a >= 1e6) return (v / 1e6).toFixed(a >= 1e7 ? 0 : 1).replace(/\.0$/, '') + 'M'
    if (a >= 1e3) return (v / 1e3).toFixed(a >= 1e4 ? 0 : 1).replace(/\.0$/, '') + 'K'
    return String(Math.round(v * 10) / 10)
}

// агрегат меры при нескольких строках на ключ (напр. месяцы): WAvg — средневзвешенно по <binding>_w
// (веса витрин), Avg — среднее, остальное (Sum и пусто) — сумма
function aggMode(field) {
    const a = String(field?.aggregate || '').toLowerCase()
    return a === 'wavg' ? 'wavg' : (a === 'avg' || a === 'average' ? 'avg' : 'sum')
}

// значение ссылочного поля строки → список ключей (массив ссылок — несколько)
function rowKeys(row, binding) {
    let v = row?.[binding]
    if (v == null || v === '') return []
    if (Array.isArray(v)) return v.filter(x => x != null && x !== '' && x !== 'NULL').map(x => (typeof x === 'object' ? (x.value || x.id) : x)).filter(Boolean).map(String)
    if (typeof v === 'string' && v.startsWith('{') && v.endsWith('}')) {   // text[] PostgreSQL как строка '{a,b,NULL}'
        return v.slice(1, -1).split(',').map(x => x.trim().replace(/^"|"$/g, '')).filter(x => x && x !== 'NULL')
    }
    if (typeof v === 'object') v = v.value || v.id
    return v ? [String(v)] : []
}

function bbox(features) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
    const walk = (coords) => {
        if (typeof coords[0] === 'number') {
            minX = Math.min(minX, coords[0]); maxX = Math.max(maxX, coords[0])
            minY = Math.min(minY, coords[1]); maxY = Math.max(maxY, coords[1])
        } else coords.forEach(walk)
    }
    features.forEach(f => walk(f.geometry.coordinates))
    return Number.isFinite(minX) ? { minX, minY, maxX, maxY } : null
}

let geoAssetPromise = null
function loadGeoAsset() {
    // ассет грузится отдельным чанком один раз на сессию
    if (!geoAssetPromise) geoAssetPromise = import(/* webpackChunkName: "geo-world" */ '@/assets/geo/world-110m.json').then(m => m.default || m)
    return geoAssetPromise
}

// IE 2026 09 30 / ODOO-343341 (заказ Игоря: вкладки легенды карты на AttrTabPanel): окно легенды без AttrTabPanel (fe.ux.mapLegendTabPanel = false) — тело вкладок как есть, без обёрток и лишних узлов
const GeoMapLegendPlain = {
    name: 'GeoMapLegendPlain',
    inheritAttrs: false,
    emits: ['local-select'],
    render() { const s = this.$slots; return [s['tab-node'] ? s['tab-node']() : null, s['tab-legend'] ? s['tab-legend']() : null] },
}

export default {
    components: { AntPlayer, GeoMapLegendPlain },   // IE 2026 09 30 / ODOO-343341 (заказ Игоря: вкладки легенды карты на AttrTabPanel)
    mixins: [legendOwnerMixin],   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({
        WIDGET: {},
        // attr приходит присваиванием из store.widget_attr_set — объявлен здесь, чтобы вычисляемые от него были реактивны
        attr: {},
        labels: [],
        overlayPoints: [],
        overlayLinks: [],
        antTick: 0, antStats: '', antClockObj: null, antMonth: '', antDpr: 1,   // IE 2026 09 15: муравьи по связям
        antMonthView: '',   // IE 2026 09 15 (замечание Игоря): месяц часов, которым красятся территории и меряются точки ('' — итоги)
        legendIslandH: 0,   // IE 2026 09 15: высота островка легенды шкалы — плеер муравьёв ставится над ним
        overlaySize: { w: 0, h: 0 },
        scaleInfo: null,
        emptyMessage: '',
        isVisible: true,
        geoReady: false,
        matchedCount: 0,
        // активный показатель легенды (не сохраняется в запись — как видимость серий чарта); '' = из настроек
        activeBinding: '',
        legendPanelVisible: false,
        legendPos: null, legendPortal: null, legendDefTick: 0,
        legendTab: 'node',   // IE 2026 09 16 / ODOO-5800 (заказ Игоря): вкладка легенды — node (наведённый элемент) | legend
        show: { links: true, nodes: true, suppliers: true, countries: true },   // IE 2026 09 17 / ODOO-… (заказ Игоря): переключатели легенды
        legendBox: { w: 0, h: 0 },   // IE 2026 09 17 / ODOO-… (замечание Игоря): достигнутый размер окна легенды — обратно не сжимаем
        legendHover: null, hoverLink: null,   // IE 2026 09 16 (постановка Игоря): последний наведённый элемент карты (узел / связь / страна) и связь под курсором   // IE 2026 09 16 (заказ Игоря): свободное окно легенды — положение (px containing block) и портал
        hoverKey: null,
        hoverPoint: null,
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    mounted() {
        this.store?.cssClasses_loadAll?.(); this.stateStyles_sync()   // IE 2026 09 18 / ODOO-… (заказ Игоря): цвета категорий — от именованных стилей
        this.antDpr = window.devicePixelRatio || 1
        if (this.WIDGET) this.WIDGET._geomap = true   // IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): класс widget-geomap на рамке виджета — шапка островками при скрытых табах
        this.WIDGET.attrsResize?.push(this.attrResize)
        loadGeoAsset().then(geo => {
            this._geo = markRaw(geo)
            this.geoReady = true
            this.$nextTick(() => { this.attrResize(); this.render() })
        }).catch(e => { console.warn('AttrGeoMap: geo asset failed', e); this.emptyMessage = this.t('Map data is not available') })   // IE 2026 09 23 / ODOO-341407: i18n
        // U6 (заказ Игоря: объяснение элементов по Alt): территорию рисует wijmo FlexMap (своего DOM-узла на страну нет) — источник altTooltip
        // «по точке» на хосте карты: страна под курсором — тем же hitTest карты, что наведение (onHostMove), но в самой точке курсора (hoverKey
        // обновляется позже и снимается с задержкой 350 мс); точки, связи, подписи — свой SVG-оверлей со своими v-uiHelp (chart.map.point / link / …),
        // сюда не попадают. Now — в отборе / раскраска состоянием / одна краска / шкала; подсказка у курсора и без дожития после Alt
        if (this.$refs.host) {
            this.$refs.host.__altTipAt = (x, y) => {
                if (!uiHelp_enabled() || !this._map) return null
                let key = null
                try { const ht = this._map.hitTest(new MouseEvent('mousemove', { clientX: x, clientY: y })); key = (ht && ht.item) ? (ht.item.__key ?? null) : null } catch (e) { key = null }   // как событие мыши onHostMove
                if (!key) return null
                const si = this.scaleInfo
                const state = this.selectedKeys.has(key) ? 'selected' : (si && si.categories ? 'state' : (si && si.single ? 'single' : 'scale'))
                const html = uiHelp_html('chart.map.territory', { state })
                return html ? { content: html, rect: new Rect(x - 8, y - 8, 16, 16), noLinger: true } : null
            }
            this.$refs.host.setAttribute('data-alt-tip-at', '')
        }
        this._onResize = () => this.attrResize()
        window.addEventListener('resize', this._onResize)
    },
    unmounted() {
        this.antStop()   // IE 2026 09 15: муравьи
        if (this._onResize) window.removeEventListener('resize', this._onResize)
        if (this._map) { try { this._map.dispose() } catch (e) { /* уже снят */ } this._map = null }
    },
    computed: {
        fields() {
            return this.store.fieldsNoHierarchy(
                this.attr?.attrs?.length
                    ? this.attr.attrs
                    : (this.WIDGET?.record?.doc?.viewList || this.WIDGET?.record?.doc?.fields || [])
            ).filter(f => f && f.use !== false)
        },
        // меры легенды — видимые числовые поля; скрытые (chart_hidden) годятся для размера точек и толщины связей
        numericFields() {
            return this.fields.filter(a => (a.attr_type === 'AttrNumber' || a.attr_type === 'AttrDays' || a.attr_type === 'AttrTime') && a.binding)
        },
        // ---- IE 2026 09 16 (постановка Игоря: легенда карты): поля состояния запаса, запаса на конец, просроченного, прихода / расхода —
        // по именам витрины (переопределяются настройками map_*_binding); режим состояния — активная мера DOS красит страны состоянием
        stateBinding() { return this.fieldByName('map_state_binding', 'stock_state') },
        stateEndBinding() { return this.fieldByName('map_state_end_binding', 'stock_state_end') },
        pointEndBinding() { return this.numericByName('map_point_end_binding', 'close_balance') },
        expiredBinding() { return this.numericByName('map_expired_binding', 'expired_open_balance') },
        inBinding() { return this.numericByName('map_in_binding', 'IN') },
        inUncBinding() { return this.inBinding ? this.numericByName('', this.inBinding + '_uncovered') : '' },
        outBinding() { return this.numericByName('map_out_binding', this.antScatterBinding || this.pointRingBinding || 'OUT') },
        outUncBinding() { return this.outBinding ? this.numericByName('', this.outBinding + '_uncovered') : '' },
        dosBinding() { return this.numericByName('map_dos_binding', 'DOS') },
        dosEndBinding() { return this.numericByName('map_dos_end_binding', 'DOS_end') },
        stateMode() { return !!this.stateBinding && !!this.dosBinding && this.valueBinding === this.dosBinding },
        measures() {
            // IE 2026 09 16: веса средневзвешенных (<мера>_w) — не меры легенды
            return this.numericFields.filter(a => !a.chart_hidden && !(/_w$/.test(a.binding) && this.numericFields.some(b => b.binding === a.binding.slice(0, -2))))
        },
        geoBinding() {
            return this.attr?.map_geo_binding
                || this.fields.find(f => f.attr_type === 'AttrLink' && f.relation_segment)?.binding || ''
        },
        geoField() { return this.fields.find(f => f.binding === this.geoBinding) },
        geo2Binding() { return this.attr?.map_geo2_binding || '' },
        // точки и связи
        // IE 2026 09 15 (заказ Игоря: цепочка на карте): точки из НЕСКОЛЬКИХ полей строки — 'subject_from,subject_to' (ключи всех полей;
        // территория точки — поле с тем же номером в map_point_geo_binding); мера размера — альтернативы через '|': первая, по которой у
        // точки есть значение ('open_balance|IN_shipped' — склад по запасу, поставщик по отгрузкам)
        pointBindings() { return String(this.attr?.map_point_binding || '').split(',').map(s => s.trim()).filter(Boolean) },
        pointBinding() { return this.pointBindings[0] || '' },
        pointField() { return this.fields.find(f => f.binding === this.pointBinding) },
        pointGeoBindings() {
            const g = String(this.attr?.map_point_geo_binding || '').split(',').map(s => s.trim()).filter(Boolean)
            return this.pointBindings.map((b, i) => g[i] || g[g.length - 1] || this.geoBinding)
        },
        pointGeoBinding() { return this.pointGeoBindings[0] || this.geoBinding },
        pointSizeBindings() {
            const list = String(this.attr?.map_point_size_binding || '').split('|').map(s => s.trim()).filter(b => b && this.numericFields.some(m => m.binding === b))
            return list.length ? list : (this.valueBinding ? [this.valueBinding] : [])
        },
        pointSizeBinding() { return this.pointSizeBindings[0] || '' },
        pointSizeFields() { return this.pointSizeBindings.map(b => this.fields.find(f => f.binding === b)).filter(Boolean) },
        pointSizeField() { return this.pointSizeFields[0] },
        pointSizeTitle() { return this.pointSizeFields.map(f => f.title || f.binding).join(' | ') || this.pointSizeBinding },
        pointsTitle() { return this.pointField?.title || this.pointBinding },
        // IE 2026 09 15 (замечание Игоря): глиф точки — внешний круг (кольцо, напр. продажи) и красное ядро (напр. непокрытые продажи);
        // ядро без настройки — OUT_uncovered / поле *_uncovered
        pointRingBinding() { const b = this.attr?.map_point_ring_binding; return (b && this.numericFields.some(m => m.binding === b)) ? b : '' },
        pointCoreBinding() {
            const b = this.attr?.map_point_core_binding
            if (b && this.numericFields.some(m => m.binding === b)) return b
            const nf = this.numericFields
            return (nf.find(m => m.binding === 'OUT_uncovered') || nf.find(m => /uncovered$/i.test(m.binding)))?.binding || ''
        },
        pointRingField() { return this.fields.find(f => f.binding === this.pointRingBinding) },
        pointCoreField() { return this.fields.find(f => f.binding === this.pointCoreBinding) },
        pointRingTitle() { return this.pointRingField ? (this.pointRingField.title || this.pointRingBinding) : '' },
        pointCoreTitle() { return this.pointCoreField ? (this.pointCoreField.title || this.pointCoreBinding) : '' },
        // IE 2026 09 15 (заказ Игоря: цепочка на карте): мера «разбегания» — продажи узла муравьями во все стороны в рамках его территории
        antScatterBinding() { const b = this.attr?.map_ants_scatter_binding; return (b && this.numericFields.some(m => m.binding === b)) ? b : '' },
        antScatterField() { return this.fields.find(f => f.binding === this.antScatterBinding) },
        antScatterTitle() { return this.antScatterField ? (this.antScatterField.title || this.antScatterBinding) : '' },
        showSwitches() {
            const out = []
            // IE 2026 09 23 / ODOO-341407: i18n
            if (this.linkFromBinding) out.push({ key: 'links', title: this.t('Links'), on: this.show.links !== false })
            if (this.pointBinding) out.push({ key: 'nodes', title: this.t('Nodes'), on: this.show.nodes !== false })
            if (this.pointBindings.length > 1 || [...this.pointsAll.values()].some(p => !p.isNode)) out.push({ key: 'suppliers', title: this.t('Supply nodes'), on: this.show.suppliers !== false })
            out.push({ key: 'countries', title: this.t('Country colouring'), on: this.show.countries !== false })
            return out
        },
        antsActive() { return this.overlayLinks.length > 0 || (!!this.antScatterBinding && this.overlayPoints.length > 0) },
        antPlayerStyle() { return (this.legendOn && this.scaleInfo && this.legendIslandH) ? { bottom: (this.legendIslandH + 14) + 'px' } : {} },
        antDateBindingC() { const b = this.attr?.map_ants_date || 'date'; return (this.rows || []).some(r => r && r[b]) ? b : '' },
        pointMaxR() { const v = +this.attr?.map_point_max; return Number.isFinite(v) && v > POINT_MIN_R ? v : 22 },
        linkFromBinding() { return this.attr?.map_link_from_binding || '' },
        linkToBinding() { return this.attr?.map_link_to_binding || '' },
        linkValueBinding() {
            const b = this.attr?.map_link_value_binding
            return (b && this.numericFields.some(m => m.binding === b)) ? b : this.valueBinding
        },
        linkValueTitle() { return this.fields.find(f => f.binding === this.linkValueBinding)?.title || this.linkValueBinding },
        // IE 2026 09 16 (заказ Игоря): непокрытый объём связи — map_link_uncovered_binding, по умолчанию «<мера связи>_uncovered»; связь с
        // непокрытым объёмом (в месяце плеера / в итогах) рисуется красной, её муравьи — красные; без непокрытого — обычный цвет
        linkUncBinding() {
            const b = this.attr?.map_link_uncovered_binding
            if (b && this.numericFields.some(m => m.binding === b)) return b
            const d = this.linkValueBinding ? this.linkValueBinding + '_uncovered' : ''
            return (d && this.numericFields.some(m => m.binding === d)) ? d : ''
        },
        linkUncTitle() { return this.fields.find(f => f.binding === this.linkUncBinding)?.title || this.linkUncBinding },
        uncColor() { return UNC_COLOR },
        // непокрытая часть меры разбегания (продаж узла) — map_ants_scatter_uncovered_binding, по умолчанию «<мера>_uncovered»
        antScatterUncBinding() {
            const b = this.attr?.map_ants_scatter_uncovered_binding
            if (b && this.numericFields.some(m => m.binding === b)) return b
            const d = this.antScatterBinding ? this.antScatterBinding + '_uncovered' : ''
            return (d && this.numericFields.some(m => m.binding === d)) ? d : ''
        },
        antScatterUncField() { return this.fields.find(f => f.binding === this.antScatterUncBinding) },
        linkColor() { return this.attr?.map_link_color || DEFAULT_LINK },
        // IE 2026 09 14 / ODOO-5800 (заказ Игоря): как на графике — «Highlight linked nodes on hover (dim the rest)»: наведённый /
        // отобранный узел и узлы на концах его входящих и исходящих связей подсвечены, остальные узлы и связи приглушены
        hoverLinksOn() { return this.attr?.map_hover_links !== false },
        litPoints() {
            const out = new Set()
            if (!this.hoverLinksOn) return out
            const seeds = new Set([...(this.hoverPoint ? [this.hoverPoint] : []), ...this.selectedPointKeys])
            if (!seeds.size || !this.overlayPoints.length) return out
            for (const k of seeds) out.add(k)
            for (const l of this.linksData.values()) {
                if (seeds.has(l.from)) out.add(l.to)
                if (seeds.has(l.to)) out.add(l.from)
            }
            return out
        },
        defaultBinding() {
            const b = this.attr?.map_value_binding
            return (b && this.measures.some(m => m.binding === b)) ? b : (this.measures[0]?.binding || '')
        },
        valueBinding() {
            return (this.activeBinding && this.measures.some(m => m.binding === this.activeBinding)) ? this.activeBinding : this.defaultBinding
        },
        valueField() { return this.fields.find(f => f.binding === this.valueBinding) },
        valueTitle() {
            if (this.attr?.map_value_title && this.valueBinding === this.defaultBinding) return this.attr.map_value_title
            return this.valueField?.title || this.valueBinding
        },
        colors() {
            const raw = String(this.attr?.map_colors || '').split(',').map(s => s.trim()).filter(Boolean)
            return raw.length >= 2 ? raw : DEFAULT_COLORS
        },
        seaColor() { return this.attr?.map_color_sea || DEFAULT_SEA },
        emptyColor() { return this.attr?.map_color_empty || DEFAULT_EMPTY },
        // выключатели: настройка виджета и глобальный флаг fe.ux.geoMapSketch (default ON)
        sketchOn() { return this.attr?.map_sketch !== false && this.store.setting('fe.ux.geoMapSketch', true) !== false },
        // IE 2026 09 16 / ODOO-5800 (заказ Игоря): при открытой легенде подписи наведения компактные — чекбокс, иконка, название (данные — во вкладке Node);
        // выключатель fe.ux.geoMapCompactHover=false — прежние подписи с показателями
        compactHover() { return this.legendPanelVisible && this.store.setting('fe.ux.geoMapCompactHover', true) !== false },
        // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): меры в бейдже наведения — только пока зажат Alt (и дожитие после
        // отпускания, как у подсказок), в режиме Show tooltips и при fe.ux.hoverTooltips=true; без Alt — чекбокс селектора, иконка записи, название
        badgeDetailsOn() {
            const epoch = this.store.altTipEpoch || 0, show = !!this.store.showTooltip   // реактивные зависимости: эхо Alt (altTooltip._epoch) и опция
            return epoch >= 0 && (show || altTooltip.detailsOn())
        },
        // затухание блока мер после отпускания Alt (пауза прошла): класс alt-details-fading (CSS в App.vue), длительность — fe.data.altTooltipFadeMs
        badgeDetailsFading() {
            const epoch = this.store.altTipEpoch || 0
            return epoch >= 0 && !this.store.showTooltip && altTooltip.detailsFading()
        },
        badgeFadeStyle() {
            return this.badgeDetailsFading ? { transitionDuration: (typeof altTooltip.fadeMs === 'function' ? altTooltip.fadeMs() : 600) + 'ms' } : null
        },
        // наведённая подпись без подробностей — как при открытой легенде (compactHover): флаг и название, без значения и блока мер
        badgeCompact() { return this.compactHover || !this.badgeDetailsOn },
        // IE 2026 09 16 / ODOO-5800 (заказ Игоря): всплывающая подсказка wijmo над территорией не показывается (данные — в легенде и подписях); fe.ux.geoMapTooltip=true — вернуть
        mapTooltipOn() { return this.store.setting('fe.ux.geoMapTooltip', false) === true },
        labelsOn() { return this.attr?.map_labels !== false },
        antsOn() { return this.attr?.map_ants === true },   // IE 2026 09 15 / ODOO-… (замечание Игоря): муравьи по связям карты
        antsTotalStart() { return this.attr?.map_ants_total !== false },   // IE 2026 09 16 (заказ Игоря): старт в режиме Σ (итоги за весь период), false — ход по месяцам
        legendOn() { return this.attr?.map_legend !== false },
        contextOn() { return this.attr?.map_context !== false },
        marks() { return this.attr?.marks || {} },
        rows() {
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[binding]
            return Array.isArray(data) ? data : []
        },
        // значения ВСЕХ мер на территорию (первое и второе гео-поле вместе): строки с одним ключом агрегируются по агрегату меры
        valuesAll() {
            const bindings = [this.geoBinding, this.geo2Binding].filter(Boolean)
            return this.aggregateBy(row => bindings.flatMap(b => rowKeys(row, b)), this.measures)
        },
        // IE 2026 09 15 (замечание Игоря): значения мер на территорию ПО МЕСЯЦАМ (ключ YYYY-MM-01 поля даты муравьёв) — при муравьях
        // территории красятся значением месяца часов
        valuesAllByMonth() {
            const db = this.antDateBindingC
            if (!db) return new Map()
            const bindings = [this.geoBinding, this.geo2Binding].filter(Boolean)
            return this.aggregateBy(row => bindings.flatMap(b => rowKeys(row, b)), this.measures, row => antMonthKey(row[db]))
        },
        // значения мер текущего вида: месяц часов (муравьи) или итоги
        valuesAllView() { const m = this.antMonthView; return m ? (this.valuesAllByMonth.get(m) || new Map()) : this.valuesAll },
        // значение активной меры на территорию (текущий вид)
        valuesByKey() {
            const out = new Map(), vb = this.valueBinding
            for (const [k, vals] of this.valuesAllView) if (Number.isFinite(vals[vb])) out.set(k, vals[vb])
            return out
        },
        // шкала активной меры по ВСЕМ месяцам — цвет территории сравним между месяцами (шкала не пересчитывается на каждый месяц)
        monthScale() {
            const vb = this.valueBinding
            let min = Infinity, max = -Infinity
            for (const mp of this.valuesAllByMonth.values()) for (const vals of mp.values()) { const v = vals[vb]; if (Number.isFinite(v)) { if (v < min) min = v; if (v > max) max = v } }
            return Number.isFinite(min) ? [min, max] : null
        },
        // точки: ключ → {country, total: {size, ring, core, scatter}, months: {m: {…}}, place} — итоги и значения по месяцам
        // (IE 2026 09 15, замечание Игоря); place — наибольшая величина глифа (итоги и месяцы): по ней точка размещается, чтобы не
        // прыгать при смене месяца
        pointsAll() {
            const out = new Map()
            if (!this.pointBindings.length || !this.pointSizeFields.length) return out
            // IE 2026 09 16 (постановка Игоря: легенда карты): + запас на конец, просроченный, приход / расход с непокрытыми, DOS на начало и конец —
            // значения по месяцам (vals) для блока наведения и двух кругов узла (начало / конец периода)
            const F = (b) => b ? this.fields.find(f => f.binding === b) : null
            const extraFields = [this.pointEndBinding, this.expiredBinding, this.inBinding, this.inUncBinding, this.outBinding, this.outUncBinding, this.dosBinding, this.dosEndBinding,
                this.dosBinding ? this.dosBinding + '_w' : '', this.dosEndBinding ? this.dosEndBinding + '_w' : ''].map(F).filter(Boolean)
            const measures = [...new Set([...this.pointSizeFields, this.pointRingField, this.pointCoreField, this.antScatterField, this.antScatterUncField, ...extraFields].filter(Boolean))]   // IE 2026 09 16: + непокрытая часть разбегания
            const keyFn = row => this.rowPointKeys(row).map(x => x[0])
            const totals = this.aggregateBy(keyFn, measures)
            const db = this.antDateBindingC
            const byMonth = db ? this.aggregateBy(keyFn, measures, row => antMonthKey(row[db])) : new Map()
            // территория точки: из кандидатов по строкам — та, что есть среди территорий со значением (узел из витрины и он же в
            // строках связей могут нести разные справочники стран), иначе первая
            const cands = new Map(), known = this.valuesAll, nodeKeys = new Set()
            for (const row of this.rows) for (const [k, c, i] of this.rowPointKeys(row)) { if (i === 0) nodeKeys.add(k); if (c) { let s = cands.get(k); if (!s) { s = []; cands.set(k, s) } if (!s.includes(c)) s.push(c) } }   // IE 2026 09 16: узел = ключ первой привязки точек (строки узлов витрины)
            const countries = new Map()
            for (const [k, s] of cands) countries.set(k, s.find(c => known.has(c)) || s[0])
            const pos = (v) => (Number.isFinite(v) && v > 0) ? v : 0
            const rb = this.pointRingBinding, cb = this.pointCoreBinding, sb = this.antScatterBinding, ub = this.antScatterUncBinding, eb = this.pointEndBinding
            const nodeB = this.pointSizeBindings[0] || ''
            const uncSizeB = this.pointSizeBindings.find(b => /_uncovered$/.test(b)) || ''
            const glyph = (vals) => {
                let size = 0
                for (const b of this.pointSizeBindings) { const v = vals?.[b]; if (Number.isFinite(v) && v > 0) { size = v; break } }
                return { size, end: eb ? pos(vals?.[eb]) : 0, ring: rb ? pos(vals?.[rb]) : 0, core: cb ? pos(vals?.[cb]) : 0, scatter: sb ? pos(vals?.[sb]) : 0, scatterUnc: ub ? pos(vals?.[ub]) : 0,
                    unc: uncSizeB ? pos(vals?.[uncSizeB]) : 0, vals: vals || {} }
            }
            for (const [k, vals] of totals) {
                const t = glyph(vals), months = {}
                let place = Math.max(t.size, t.ring, t.core, t.end)
                const isNode = nodeKeys.has(k) || pos(vals?.[nodeB]) > 0
                for (const [m, mp] of byMonth) {
                    const mv = mp.get(k); if (!mv) continue
                    const g = glyph(mv)
                    if (g.size || g.ring || g.core || g.scatter || g.scatterUnc || g.end || g.unc) { months[m] = g; place = Math.max(place, g.size, g.ring, g.core, g.end) }
                }
                const ms = Object.keys(months).sort()
                if (place > 0) out.set(k, { country: countries.get(k) || '', total: t, months, place, isNode, first: ms[0] || '', last: ms[ms.length - 1] || '' })
            }
            return out
        },
        // IE 2026 09 17 / ODOO-… (заказ Игоря): «Flow Map::Country» — один узел на страну: меры складываются
        // по всем узлам страны, DOS — средневзвешенно по весам *_w, состояние — худшее (те же правила, что
        // у бейджа страны, countryVals). Включается настройкой виджета map_nodes_by_country.
        nodesByCountry() { return this.attr?.map_nodes_by_country === true || this.attr?.map_nodes_by_country === 'true' },
        // IE 2026 09 18 (заказ Игоря: именованные стили): реестр стилей обновился — цвета категорий запаса считаем заново
        stateStylesEpoch() { return this.store?.cssClasses_change_index || 0 },
        // IE 2026 09 18 (замечание Игоря: «при наведении на узел, связь либо страну — только её бейдж, остальные скрывать»):
        // наведённый элемент карты; приоритет — узел, затем связь, затем страна (узел и связь лежат поверх территории,
        // и страна под ними тоже считается наведённой). Внутренняя опция fe.ux.geoMapHoverExclusive (по умолчанию вкл).
        hoverFocus() {
            if (this.store?.setting?.('fe.ux.geoMapHoverExclusive', true) === false) return null
            if (this.hoverPoint) return { kind: 'point', key: this.hoverPoint }
            if (this.hoverLink) return { kind: 'link', key: this.hoverLink }
            if (this.hoverKey) return { kind: 'country', key: this.hoverKey }
            return null
        },
        // точки текущего вида (месяц часов при муравьях / итоги): ключ → {country, size, ring, core, scatter, place}
        pointsData() {
            const out = new Map(), m = this.antMonthView
            const empty = { size: 0, end: 0, ring: 0, core: 0, scatter: 0, scatterUnc: 0, unc: 0, vals: {} }
            for (const [k, p] of this.pointsAll) {
                let v
                // IE 2026 09 17 / ODOO-… (заказ Игоря): «если есть отгрузка из узла, но в текущий момент времени её нет —
                // покажи пустой узел с диаметром, равным максимальному диаметру этого узла по всем периодам»
                if (m && !p.months[m] && p.place > 0) v = { ...empty, emptyNow: true, size: p.place }
                else if (m) v = p.months[m] || empty
                else if (p.isNode) {
                    // IE 2026 09 16 (постановка Игоря): Σ — запас на НАЧАЛО периода (первый месяц) и на КОНЕЦ (последний), потоки — итоги
                    const f = p.first ? p.months[p.first] : null, l = p.last ? p.months[p.last] : null
                    v = { ...p.total, size: f ? f.size : p.total.size, end: l ? l.end : p.total.end }
                } else {
                    // узел пополнения (поставщик): диаметр — наибольший месячный объём движения, признак непокрытого — по итогам
                    let mx = 0; for (const g of Object.values(p.months)) mx = Math.max(mx, g.size)
                    v = { ...p.total, size: mx || p.total.size }
                }
                out.set(k, { country: p.country, ...v, place: p.place, isNode: p.isNode })
            }
            return this.nodesByCountry ? this.pointsByCountry(out) : out
        },
        // IE 2026 09 16 (постановка Игоря): состояния запаса точек по месяцам — {months: {m: {s, se}}}; s — на начало месяца, se — на конец
        pointStates() {
            const out = new Map(), sb = this.stateBinding, eb = this.stateEndBinding, db = this.antDateBindingC
            if (!sb && !eb) return out
            for (const row of this.rows) {
                const st = sb ? String(row?.[sb] || '').trim() : '', se = eb ? String(row?.[eb] || '').trim() : ''
                if (!st && !se) continue
                const m = (db ? antMonthKey(row[db]) : '') || 'all'
                for (const [k] of this.rowPointKeys(row)) {
                    let e = out.get(k); if (!e) { e = { months: {} }; out.set(k, e) }
                    const mm = e.months[m] || (e.months[m] = { s: '', se: '' })
                    mm.s = worseState(mm.s, st); mm.se = worseState(mm.se, se)
                }
            }
            return out
        },
        // IE 2026 09 16 (постановка Игоря): блок наведения окна легенды — узел / связь / страна (последнее наведённое держится)
        legendHoverInfo() {
            const h = this.legendHover
            if (!h) return null
            try {
                if (h.kind === 'link') return this.legendLinkInfo(h.key)
                if (h.kind === 'country') return this.legendCountryInfo(h.key)
                return this.legendNodeInfo(h.key)
            } catch (e) { return null }
        },
        // связи: 'from|to' → {from, to, value}
        linksData() {
            const out = new Map()
            if (!this.linkFromBinding || !this.linkToBinding) return out
            const fb = this.linkFromBinding, tb = this.linkToBinding, vb = this.linkValueBinding, ub = this.linkUncBinding, db = this.antDateBindingC
            const vf = this.fields.find(f => f.binding === vb)
            const mode = vf ? aggMode(vf) : 'sum'
            const acc = new Map()
            // IE 2026 09 17 / ODOO-… (заказ Игоря): «Flow Map::Country» — концы связей на узлах страны сводятся к самой стране
            const nodeCountry = this.nodesByCountry
                ? new Map([...this.pointsAll].filter(([, p]) => p.isNode && p.country).map(([k, p]) => [k, p.country]))
                : null
            const keyOf = (k) => (nodeCountry && nodeCountry.get(k)) || k
            for (const row of this.rows) {
                // IE 2026 09 16 (заказ Игоря): + непокрытый объём связи (unc) — итогом и по месяцам (месячный вид плеера)
                // IE 2026 09 16 (вопрос Игоря «маршрут PO Estimate Uncovered»): непокрытый объём — СО ЗНАКОМ (корректировки TXN отрицательны):
                // сумма по связи и месяцу, итог не ниже нуля
                const v0 = +row?.[vb], u0 = ub ? +row?.[ub] : NaN
                const v = Number.isFinite(v0) && v0 > 0 ? v0 : 0, u = Number.isFinite(u0) ? u0 : 0
                if (!v && !u) continue
                const m = db ? antMonthKey(row[db]) : ''
                for (const f0 of rowKeys(row, fb)) for (const t0 of rowKeys(row, tb)) {
                    const f = keyOf(f0), t = keyOf(t0)
                    if (f === t) continue
                    const key = f + '|' + t
                    const a = acc.get(key) || { from: f, to: t, sum: 0, n: 0, unc: 0, months: {} }
                    if (v) { a.sum += v; a.n++ }
                    a.unc += u
                    if (m) { const mm = a.months[m] || (a.months[m] = { value: 0, unc: 0 }); mm.value += v; mm.unc += u }
                    acc.set(key, a)
                }
            }
            for (const [key, a] of acc) {
                for (const mm of Object.values(a.months)) mm.unc = Math.max(0, mm.unc)
                out.set(key, { from: a.from, to: a.to, value: mode === 'sum' ? a.sum : (a.n ? a.sum / a.n : 0), unc: Math.max(0, a.unc), months: a.months })
            }
            return out
        },
        // строка-чипс стола по полю (стандартный AttrChipWhere 'in' — как у списка-селектора)
        selectionRow() { return this.selectionRowFor(this.geoBinding) },
        selectedKeys() { const out = new Set(this.selectedKeysFor(this.geoBinding)); for (const k of this.selectedKeysRow(this.selectorRowFor(this.selectorWidgetFor('country')))) out.add(k); return out },   // IE 2026 09 16: + строка виджета-селектора стран
        selectionRowPoints() { return this.selectionRowFor(this.pointBinding) },
        selectedPointKeys() {   // IE 2026 09 16: + вторая привязка (поставщики) и строки виджетов-селекторов узлов / поставщиков
            const out = new Set(this.selectedKeysFor(this.pointBinding))
            const b2 = this.pointBindings[1]; if (b2) for (const k of this.selectedKeysFor(b2)) out.add(k)
            for (const kind of ['node', 'supplier']) for (const k of this.selectedKeysRow(this.selectorRowFor(this.selectorWidgetFor(kind)))) out.add(k)
            return out
        },
        selectedSig() { return [...this.selectedKeys].sort().join('|') + '#' + [...this.selectedPointKeys].sort().join('|') },
        renderKey() {
            // всё, от чего зависит перерисовка (наблюдается одним watcher'ом); отбор — отдельно (без пересчёта зума)
            return JSON.stringify([
                [...this.valuesByKey.entries()], this.geoBinding, this.geo2Binding, this.valueBinding, this.colors, this.sketchOn, this.labelsOn,
                this.contextOn, this.emptyColor, this.attr?.map_color_min, this.attr?.map_color_max, this.attr?.map_padding,
                Object.keys(this.marks).length, this.store.itemsSource_change_index,
                [...this.pointsData.entries()], [...this.linksData.entries()], this.pointMaxR, this.linkColor,
                this.antMonthView, this.pointRingBinding, this.pointCoreBinding,   // IE 2026 09 15: месячный вид, глиф точки
            ])
        },
        // IE 2026 09 15: сигнатура потоков муравьёв — данные и привязки связей / разбегания; месячный вид карты потоки не пересобирает
        antFlowsKey() {
            // IE 2026 09 16: без store.itemsSource_change_index — приход любого словаря пересобирал потоки и сбрасывал муравьёв (в паузе на
            // одном месяце — снимок заново); связи и точки, зависящие от словарей, и так в ключе
            return JSON.stringify([[...this.linksData.entries()], this.linkColor, this.antDateBindingC, this.antScatterBinding, this.linkUncBinding, this.antScatterUncBinding,
                [...this.pointsAll.keys()]])
        },
    },
    methods: {
        overlayPortal,   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): портал страницы, а в полноэкране виджета — сам виджет
        // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
        legendOwner_flagOn() { return !!this.legendPanelVisible },
        legendOwner_close() { this.legendPanelVisible = false },
        legendOwner_related() { return false },
        content_Changed() {
            this.store.widget_attr_set(this)
        },
        handleVisibility(isVisible) {
            this.legendOwner_onVisible(isVisible)   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
            if (this.isVisible === isVisible) return
            this.isVisible = isVisible
            if (isVisible) this.$nextTick(() => { this.attrResize(); this.render() })
        },
        setActiveMeasure(binding) {
            this.activeBinding = binding
        },
        // IE 2026 09 15 (заказ Игоря: цепочка на карте): ключи точек строки со своей территорией — по каждому полю точек
        rowPointKeys(row) {
            const out = []
            const pbs = this.pointBindings, gbs = this.pointGeoBindings
            for (let i = 0; i < pbs.length; i++) { const c = rowKeys(row, gbs[i])[0] || ''; for (const k of rowKeys(row, pbs[i])) out.push([k, c, i]) }   // IE 2026 09 16: [ключ, страна, индекс привязки — 0 = узел]
            return out
        },
        // агрегация строк по ключам keyFn(row) → Map key → {binding: value} по агрегату каждой меры;
        // monthFn(row) → ключ месяца: Map month → Map key → {…} (IE 2026 09 15: значения по месяцам для муравьёв)
        aggregateBy(keyFn, measures, monthFn = null) {
            const out = new Map()
            if (!measures.length) return out
            const modes = measures.map(m => [m.binding, aggMode(m)])
            for (const row of this.rows) {
                if (!row) continue
                const keys = keyFn(row)
                if (!keys.length) continue
                let bucket = out
                if (monthFn) { const mk = monthFn(row); if (!mk) continue; bucket = out.get(mk); if (!bucket) { bucket = new Map(); out.set(mk, bucket) } }
                for (const key of keys) {
                    let acc = bucket.get(key)
                    if (!acc) { acc = {}; bucket.set(key, acc) }
                    for (const [b, mode] of modes) {
                        const v = +row[b]
                        if (!Number.isFinite(v) || row[b] === null || row[b] === undefined) continue
                        const a = acc[b] || (acc[b] = { sum: 0, w: 0, n: 0 })
                        if (mode === 'wavg') {
                            const w = +row[b + '_w']
                            const ww = Number.isFinite(w) && w > 0 ? w : 1
                            a.sum += v * ww; a.w += ww
                        } else { a.sum += v; a.n++ }
                    }
                }
            }
            const finish = (map) => {
                for (const [k, acc] of map) {
                    const vals = {}
                    for (const [b, mode] of modes) {
                        const a = acc[b]
                        if (!a) continue
                        vals[b] = mode === 'wavg' ? (a.w ? a.sum / a.w : NaN) : (mode === 'avg' ? (a.n ? a.sum / a.n : NaN) : a.sum)
                    }
                    map.set(k, vals)
                }
            }
            if (monthFn) for (const bucket of out.values()) finish(bucket); else finish(out)
            return out
        },
        // сглаженная геометрия территории — один раз на ассет (IE 2026 09 15: перерисовка по месяцам не сглаживает заново)
        smoothCached(f) {
            const c = this._smoothCache || (this._smoothCache = new WeakMap())
            let g = c.get(f)
            if (!g) { g = smoothGeometry(f.geometry); c.set(f, g) }
            return g
        },
        // шестерёнка: строка настроек вкладки (те же ключи, что Views → Map)
        onToggle_settings() {
            const vueObj = this
            const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
            if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                vueObj.store.widget_close(WRow.id)
                return
            }
            const cogEl = this.$refs.cogButton
            const widgetEl = document.getElementById('WIDGET' + vueObj.WIDGET.id)
            let x, y
            if (cogEl && widgetEl) {
                const cr = cogEl.getBoundingClientRect(), wr = widgetEl.getBoundingClientRect()
                x = cr.left - wr.left + cr.width / 2
                y = cr.top - wr.top + cr.height / 2
            }
            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, {
                command: 'widget_open', widget: 'widget-row', type: 'widget-row-viewParams',
                source_attr_type: 'AttrGeoMap', binding: vueObj.attr.binding, source_name: vueObj.attr.name,
                get_Parent: true, open_in_children_widget: true,
                widgetRow_params: { top_pct: 0.2, left_pct: 0.2, width_pct: 0.8, height_pct: 0.8 },
                selectedCog: { x, y },
            }, vueObj.attr)
        },
        attrResize() {
            // высота карты — от низа виджета (как у AttrTreeMap / AttrBubbleChart)
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`)
            const host = this.$refs.host
            if (!elementForm || !host) return
            const legendH = 0   // IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): легенда и кнопки — островки поверх карты, высоту не отнимают
            const newHeight = Math.max(160, Math.floor(elementForm.getBoundingClientRect().bottom - host.getBoundingClientRect().top) - 2 - legendH)
            if (Math.abs(host.getBoundingClientRect().height - newHeight) > 1) {
                host.style.height = `${newHeight}px`
                if (this._map) { this._map.invalidate(); this.$nextTick(() => this.fitAndLabel()) }
            }
        },
        // человеческое значение меры — форматтеры платформы (DOS в секундах → месяцы/дни); compact — короткая подпись на карте
        fmtValue(v, field, compact = false) {
            if (!Number.isFinite(v)) return ''
            if (field?.attr_type === 'AttrTime') return this.store.formatTimeHTML(v, field)
            if (field?.attr_type === 'AttrDays') return this.store.formatDaysHTML(v, field)
            if (compact) return compactNumber(v)
            try { return this.store.formatNumberHTML(v, field) || compactNumber(v) } catch (e) { return Math.round(v).toLocaleString('ru-RU') }
        },
        // IE 2026 09 14 / ODOO-5800 (замечание Игоря): флаг территории из ISO ассета (выключатель fe.ux.geoMapIsoFlags=false)
        isoFlag(props) { return this.store?.setting?.('fe.ux.geoMapIsoFlags', true) !== false ? isoToFlag(props?.iso) : '' },
        titleOf(key, binding) {
            const m = this.marks[key]
            if (m?.title) return m.title
            const seg = this.fields.find(f => f.binding === (binding || this.geoBinding))?.relation_segment
            const t = seg && this.store.itemsSource?.[seg]?.ids?.[key]?.title
            if (t) return t
            // IE 2026 09 15 (замечание Игоря: маршруты Ex-Delta на карте цепочки): территория точки может быть из другого справочника
            // (страна поставщика из DS::SUBJECTS — segment-5, а не справочник территорий карты) — ищем по справочникам полей
            // территорий точек и второй территории; справочник, которого ещё нет, запрашивается (перерисовка по его приходу)
            const segs = [...new Set([this.geo2Binding, ...this.pointGeoBindings].filter(Boolean).map(b => this.fields.find(f => f.binding === b)?.relation_segment).filter(s => s && s !== seg))]
            for (const s of segs) {
                const IS = this.store.itemsSource?.[s]
                if (!IS) { try { this.store.get_itemsSource_bySegment?.(s) } catch (e) { /* без словаря */ } continue }
                const t2 = IS?.ids?.[key]?.title
                if (t2) return t2
            }
            return key
        },
        // территория ассета по записи справочника: doc.iso → код из флага → название (алиасы / title / name_ru / name)
        featureFor(key, byIso, byName) {
            const m = this.marks[key] || {}
            const iso = (m.iso || flagToIso(m.flag) || '').toUpperCase()
            if (iso && byIso.has(iso)) return byIso.get(iso)
            const t = String(this.titleOf(key) || '').trim().toLowerCase()
            if (!t) return null
            const alias = NAME_ISO[t]
            if (alias && byIso.has(alias)) return byIso.get(alias)
            return byName.get(t) || null
        },
        ensureMap() {
            if (this._map || !this.$refs.host) return
            const layer = new GeoMapLayer({ style: { stroke: OUTLINE, strokeWidth: 1, fill: this.emptyColor } })
            layer.itemFormatter = (engine, f) => {
                const p = f.properties || {}
                const has = p.__key != null
                const sel = has && this._selected && this._selected.has(p.__key)
                engine.fill = p.__fill || this.emptyColor
                // отобранные территории обведены тёмно-синим и жирнее; с данными — жирнее контекста
                engine.stroke = sel ? OUTLINE_SELECTED : OUTLINE
                engine.strokeWidth = sel ? 3.4 : (this.sketchOn ? (has ? 2.2 : 1.3) : (has ? 1.2 : 0.6))
            }
            const map = new FlexMap(this.$refs.host, { layers: [layer], plotMargin: 0 })
            map.tooltip.content = (item) => {
                if (!this.mapTooltipOn || !item || item.__key == null || this.hoverPoint) return ''   // IE 2026 09 16 / ODOO-5800 (заказ Игоря): подсказка выключена
                const flag = item.__flag ? `${item.__flag} ` : ''
                const lines = (item.__all || []).map(x => x.active ? `${x.title}: <b>${x.text}</b>` : `${x.title}: ${x.text}`)
                return `<b>${flag}${item.__title}</b>` + (lines.length ? '<br>' + lines.join('<br>') : '')
            }
            map.rendered.addHandler(() => this.afterRender())
            // IE 2026 09 14 / ODOO-5800 (замечание Игоря): штатные кнопки + / − wijmo в углу карты спрятаны — масштаб и «вписать» в нижней полосе
            if (map._overlay?.style) map._overlay.style.display = 'none'
            this._map = markRaw(map)
            this._layer = markRaw(layer)
        },
        render() {
            if (!this.geoReady || !this.$refs.host || !this.isVisible) return
            this.ensureMap()
            const map = this._map, layer = this._layer
            const geo = this._geo
            const byIso = new Map(), byName = new Map()
            for (const f of geo.features) {
                const p = f.properties || {}
                if (p.iso) byIso.set(String(p.iso).toUpperCase(), f)
                for (const n of [p.name, p.name_ru]) if (n) byName.set(String(n).toLowerCase(), f)
            }
            this._byIso = byIso; this._byName = byName
            const values = this.valuesByKey
            const matched = new Map()   // feature → {key, value}
            for (const [key, v] of values) {
                const f = this.featureFor(key, byIso, byName)
                if (f && Number.isFinite(v)) matched.set(f, { key, value: v })
            }
            this.matchedCount = matched.size
            // IE 2026 09 15 (замечание Игоря): в месячном виде территории с данными в других месяцах, но без движения в этом — белые с «–»
            // (отсутствие движений в периоде), набор территорий тот же, что в итогах — зум не прыгает
            const quiet = new Map()
            if (this.antMonthView) for (const key of this.valuesAll.keys()) if (!values.has(key)) { const f = this.featureFor(key, byIso, byName); if (f && !matched.has(f)) quiet.set(f, key) }
            // территории точек без своей меры (страны поставщиков без значения) — тоже нужны на карте (для кружков и связей)
            const extraKeys = new Set()
            for (const p of this.pointsData.values()) if (p.country && !values.has(p.country)) extraKeys.add(p.country)
            for (const l of this.linksData.values()) for (const k of [l.from, l.to]) if (!values.has(k) && !this.pointsData.has(k)) extraKeys.add(k)
            const extraFeatures = new Map()
            for (const k of extraKeys) { const f = this.featureFor(k, byIso, byName); if (f && !matched.has(f) && !quiet.has(f)) extraFeatures.set(f, k) }
            // шкала: min/max данных или заданные границы; в месячном виде — по всем месяцам (IE 2026 09 15: цвет сравним между месяцами)
            const vals = [...matched.values()].map(x => x.value)
            const ms = this.antMonthView ? this.monthScale : null
            let min = Number.isFinite(+this.attr?.map_color_min) && this.attr?.map_color_min !== '' && this.attr?.map_color_min != null ? +this.attr.map_color_min : (ms ? ms[0] : Math.min(...vals))
            let max = Number.isFinite(+this.attr?.map_color_max) && this.attr?.map_color_max !== '' && this.attr?.map_color_max != null ? +this.attr.map_color_max : (ms ? ms[1] : Math.max(...vals))
            if (!Number.isFinite(min) || !Number.isFinite(max)) { min = 0; max = 1 }
            // IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): все значения равны (и границы не заданы) — красить как «самое маленькое» некорректно:
            // одно значение = один нейтральный цвет (attr.map_single_color), легенда — сплошная полоса с одной подписью
            const single = vals.length > 0 && max <= min && !(this.attr?.map_color_min != null && this.attr?.map_color_min !== '') && !(this.attr?.map_color_max != null && this.attr?.map_color_max !== '')
            const singleColor = String(this.attr?.map_single_color || '#8fa8c8')
            if (max <= min) max = min + 1
            const colorOf = single ? () => singleColor : (v) => paletteColor(this.colors, (v - min) / (max - min))
            const sketch = this.sketchOn
            const features = []
            const vb = this.valueBinding
            for (const f of geo.features) {
                const m = matched.get(f)
                const extra = extraFeatures.get(f)
                const q = quiet.get(f)
                if (!m && !extra && !q && !this.contextOn) continue
                if (!m && !extra && !q && f.properties?.micro) continue   // АН 2026 10 25 / ODOO-347310 (замечание ie-engine7): кружок микрогосударства без данных не рисуем — он поверх соседа (Ватикан на Риме) и перехватывал наведение
                const props = { ...(f.properties || {}) }
                if (m) {
                    const mark = this.marks[m.key] || {}
                    const all = this.valuesAllView.get(m.key) || {}
                    props.__key = m.key; props.__value = m.value; props.__fill = this.show.countries === false ? this.emptyColor : (this.stateMode ? this.stateColorFor(m.key) : colorOf(m.value))   // IE 2026 09 16: режим состояния запаса
                    props.__valueSort = Number((this.valuesAll.get(m.key) || {})[vb]) || 0   // IE 2026 09 15: порядок бейджей — по итогам (устойчив по месяцам)
                    props.__title = this.titleOf(m.key); props.__flag = mark.flag || this.isoFlag(props)   // IE 2026 09 14 / ODOO-5800: флаг из ISO, если в справочнике нет
                    props.__text = this.fmtValue(m.value, this.valueField, true)
                    // подсказка: все меры территории, активная — жирным
                    props.__all = this.measures.filter(x => Number.isFinite(all[x.binding]))
                        .map(x => ({ title: x.title || x.binding, text: this.fmtValue(all[x.binding], x), active: x.binding === vb }))
                } else if (q) {   // IE 2026 09 15: без движения в этом месяце
                    props.__key = q; props.__fill = this.emptyColor; props.__title = this.titleOf(q); props.__flag = (this.marks[q] || {}).flag || this.isoFlag(props)
                    props.__text = '–'; props.__all = []; props.__valueSort = Number((this.valuesAll.get(q) || {})[vb]) || 0
                } else if (extra) {
                    // IE 2026 09 17 / ODOO-… (заказ Игоря): страна ПОСТАВЩИКА — подпись есть, но по умолчанию скрыта
                    // (__hiddenLabel): при наведении / отборе показывается бейдж с флагом, тайтлом и чекбоксом селектора
                    props.__key = extra; props.__fill = this.emptyColor; props.__title = this.titleOf(extra); props.__flag = (this.marks[extra] || {}).flag || this.isoFlag(props)
                    props.__text = ''; props.__all = []; props.__hiddenLabel = true
                } else props.__fill = this.emptyColor
                features.push({ type: 'Feature', properties: props, geometry: sketch ? this.smoothCached(f) : f.geometry })
            }
            this._matchedFeatures = features.filter(f => f.properties.__key != null)
            const cats = this.stateMode ? this.stateCategoriesPresent() : null   // IE 2026 09 16 (постановка Игоря): страны по состоянию запаса — категории вместо шкалы
            this.scaleInfo = (matched.size || quiet.size) ? (cats ? {
                minText: '', maxText: '', single: false, categories: cats,
                gradient: cats.length ? `linear-gradient(90deg, ${cats.map((c, i) => `${c.color} ${Math.round(100 * i / cats.length)}% ${Math.round(100 * (i + 1) / cats.length)}%`).join(', ')})` : this.emptyColor,
            } : single ? {   // IE 2026 09 15: месяц без движения — легенда шкалы остаётся
                minText: this.fmtValue(min, this.valueField, true), maxText: '', single: true,   // IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): одно значение
                gradient: singleColor,
            } : {
                minText: this.fmtValue(min, this.valueField, true), maxText: this.fmtValue(max, this.valueField, true),   // IE 2026 09 14 (Igor): компактно
                gradient: `linear-gradient(90deg, ${this.colors.join(', ')})`,
            }) : null
            if (!this.antMonthView) this.emptyMessage = !this.rows.length ? this.t('No data') : (!matched.size && !this.pointsData.size ? this.t('No territories matched the data') : '')   // IE 2026 09 23 / ODOO-341407: i18n   // IE 2026 09 15: месяц без данных — не «нет данных»
            // зум на территории с данными — только когда их набор изменился (переключение меры / отбор зум не сбрасывают)
            const fitSig = this._matchedFeatures.map(f => f.properties.__key).sort().join('|')
            if (fitSig !== this._fitSig) { this._fitSig = fitSig; this._fitPending = true }
            this._selected = new Set(this.selectedKeys)
            layer.itemsSource = { type: 'FeatureCollection', features }
            layer.invalidate()
            map.invalidate(true)
            this.$nextTick(() => this.attrResize())
        },
        // после отрисовки: зум на территории с данными (один раз на выборку), фильтр «дрожания», подписи, оверлей
        afterRender() {
            const map = this._map
            if (!map) return
            this.applySketchFilter()
            this.$nextTick(() => this.legendIslandMeasure())   // IE 2026 09 15: плеер над легендой (островок появляется после отрисовки)
            if (this._fitPending) {
                this._fitPending = false
                if (this.fitToMatched()) return   // fit меняет center/zoom → ещё один rendered
            }
            this.placeLabels()
            this.layoutOverlay()
        },
        fitAndLabel() { this._fitPending = true; this._map?.invalidate() },
        // IE 2026 09 15 (замечание Игоря): высота островка легенды шкалы — плеер муравьёв ставится над ним
        legendIslandMeasure() {
            const li = this.$refs.attr_container?.querySelector?.('.attr-geomap-island-legend')   // $el — корень Attr, не контейнер карты
            const h = li ? Math.ceil(li.getBoundingClientRect().height) : 0
            if (h !== this.legendIslandH) this.legendIslandH = h
        },
        // IE 2026 09 14 / ODOO-5800 (замечание Игоря): масштаб шагом wijmo (_zoomStep 0.5, минимум 1); подписи и оверлей
        // перекладываются по событию rendered (afterRender)
        zoomBy(dir) {
            const map = this._map
            if (!map) return
            const step = Number.isFinite(map._zoomStep) ? map._zoomStep : 0.5
            map.zoom = Math.max(1, Math.round((map.zoom + dir * step) * 100) / 100)
        },
        fitToMatched() {
            const map = this._map
            const feats = this._matchedFeatures || []
            const bb = feats.length ? bbox(feats) : null
            if (!bb || !map._mapRect) return false
            const pad = Number.isFinite(+this.attr?.map_padding) && this.attr?.map_padding !== '' && this.attr?.map_padding != null ? +this.attr.map_padding : 12
            const k = 1 + Math.max(0, pad) / 100
            const cx = (bb.minX + bb.maxX) / 2, cy = (bb.minY + bb.maxY) / 2
            const hw = Math.max(0.5, (bb.maxX - bb.minX) / 2 * k), hh = Math.max(0.5, (bb.maxY - bb.minY) / 2 * k)
            // считаем зум сами: zoomTo wijmo умножает зум на себя (верен только при zoom=1)
            map.zoom = 1
            map.center = new Point(cx, cy)
            const p1 = map.convert(new Point(cx - hw, cy - hh)), p2 = map.convert(new Point(cx + hw, cy + hh))
            const w = Math.abs(p2.x - p1.x), h = Math.abs(p2.y - p1.y)
            if (!(w > 0 && h > 0)) return false
            const ratio = Math.min(map._mapRect.width / w, map._mapRect.height / h)
            const z = 1 + Math.log2(ratio)
            if (!Number.isFinite(z)) return false
            map.zoom = Math.max(0, Math.round(z * 100) / 100)
            map.center = new Point(cx, cy)
            return true
        },
        applySketchFilter() {
            const host = this.$refs.host
            const svg = host?.querySelector('svg')
            if (!svg) return
            const id = `ie-geomap-sketch-${this.attr_id}`
            let defs = svg.querySelector('defs')
            if (!defs) { defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs'); svg.insertBefore(defs, svg.firstChild) }
            let filter = svg.querySelector(`#${CSS.escape(id)}`)
            if (!filter) {
                // фильтр в пиксельном пространстве внешней группы (clip-группа карты не масштабируется)
                filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter')
                filter.setAttribute('id', id)
                filter.setAttribute('x', '-2%'); filter.setAttribute('y', '-2%'); filter.setAttribute('width', '104%'); filter.setAttribute('height', '104%')
                filter.innerHTML = '<feTurbulence type="fractalNoise" baseFrequency="0.018" numOctaves="2" seed="7" result="n"/>'
                    + '<feDisplacementMap in="SourceGraphic" in2="n" scale="3.5" xChannelSelector="R" yChannelSelector="G"/>'
                defs.appendChild(filter)
            }
            const g = this._layer?._g?.parentNode
            if (g && g.tagName === 'g') {
                if (this.sketchOn) g.setAttribute('filter', `url(#${id})`)
                else g.removeAttribute('filter')
            }
        },
        placeLabels() {
            const map = this._map, host = this.$refs.host
            if (!map || !host) { this.labels = []; return }
            const hr = host.getBoundingClientRect()
            const out = []
            const centers = new Map()   // ключ территории → {x, y, feature} (для точек и связей)
            for (const f of this._matchedFeatures || []) {
                const c = centroid(f.geometry)
                if (!c) continue
                const p = map.convert(new Point(c[0], c[1]))
                if (!Number.isFinite(p.x) || !Number.isFinite(p.y)) continue
                centers.set(f.properties.__key, { x: p.x, y: p.y, feature: f })
                if (f.properties.__nolabel) continue
                if (p.x < 0 || p.y < 0 || p.x > hr.width || p.y > hr.height) continue
                out.push({ key: f.properties.__key, x: Math.round(p.x), y: Math.round(p.y), flag: f.properties.__flag, text: f.properties.__text, title: f.properties.__title,
                    always: !!f.properties.__hiddenLabel })   // IE 2026 09 17: страна поставщика — только при наведении / отборе
            }
            this._centers = centers
            // разведение подписей соседних мелких стран (Армения / Азербайджан): пересекающиеся сдвигаем вниз
            const width = (l) => this.labelWidth(l)
            // IE 2026 09 14 / ODOO-… (замечание Игоря: бейджи, которым нет места): на мелком масштабе сдвиг «столбиком» уводил бейджи Европы
            // на Африку — теперь бейдж, которому нет места, прячется до наведения на его территорию (или отбора). Порядок
            // размещения: сначала бейджи, целиком влезающие в свою территорию, затем по убыванию значения; пересекающийся с уже
            // поставленным — скрыт. Выкл (прежний сдвиг вниз): window.fe.set('ux.geomapLabelsHide', false)
            if (this.store.setting('fe.ux.geomapLabelsHide', true) !== false) {
                const lh = 20
                const fits = (l) => {
                    const c = centers.get(l.key), ring = c && mainRing(c.feature.geometry)
                    if (!ring) return false
                    const w = width(l) / 2, h = lh / 2
                    for (const [dx, dy] of [[-w, -h], [w, -h], [w, h], [-w, h]]) {
                        const g = map.convertBack(new Point(l.x + dx, l.y + dy))
                        if (!pointInRing(ring, g.x, g.y)) return false
                    }
                    return true
                }
                for (const l of out) { if (l.always) { l.fit = false; l.value = -1; continue } const pr = centers.get(l.key)?.feature?.properties || {}; l.fit = fits(l); l.value = Number.isFinite(pr.__valueSort) ? pr.__valueSort : (Number(pr.__value) || 0) }   // IE 2026 09 15: порядок по итогам
                out.sort((a, b) => (b.fit - a.fit) || (b.value - a.value) || (a.y - b.y))
                const placed = []
                for (const l of out) {
                    if (l.always) { l.hidden = true; continue }   // IE 2026 09 17: страна поставщика — бейдж по наведению
                    const w = width(l)
                    l.hidden = placed.some(p => Math.abs(p.x - l.x) < (width(p) + w) / 2 + 4 && Math.abs(p.y - l.y) < lh + 2)
                    if (!l.hidden) placed.push(l)
                }
            } else {
                out.sort((a, b) => a.y - b.y)
                for (let i = 0; i < out.length; i++) {
                    for (let j = 0; j < i; j++) {
                        const a = out[j], b = out[i]
                        if (Math.abs(a.x - b.x) < (width(a) + width(b)) / 2 && Math.abs(a.y - b.y) < 20) b.y = a.y + 20
                    }
                }
            }
            this.labels = out
        },
        labelWidth(l) { return this.labelsOn ? 8 * String((l.flag ? 'xx ' : '') + (l.text || '')).length + 34 : 24 },
        // IE 2026 09 17 / ODOO-… (замечание Игоря): контуры территорий в ЭКРАННЫХ координатах — препятствия для дуг связей.
        // Считаются раз на вид карты (зум / центр / размер холста), точки контура прорежены до ~120 на территорию.
        ringsScreen(map) {
            const sig = JSON.stringify([map.zoom, map.center && map.center.x, map.center && map.center.y, this.overlaySize.w, this.overlaySize.h, (this._matchedFeatures || []).length])
            if (this._ringsScr && this._ringsScr.sig === sig) return this._ringsScr.rings
            const rings = []
            for (const f of this._matchedFeatures || []) {
                const ring = mainRing(f.geometry)
                if (!ring || ring.length < 4) continue
                const step = Math.max(1, Math.floor(ring.length / 120))
                const pts = []
                let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity
                for (let i = 0; i < ring.length; i += step) {
                    const p = map.convert(new Point(ring[i][0], ring[i][1]))
                    if (!p || !Number.isFinite(p.x) || !Number.isFinite(p.y)) continue
                    pts.push([p.x, p.y])
                    if (p.x < x0) x0 = p.x
                    if (p.x > x1) x1 = p.x
                    if (p.y < y0) y0 = p.y
                    if (p.y > y1) y1 = p.y
                }
                if (pts.length > 3) rings.push({ key: f.properties.__key, pts, x0, y0, x1, y1 })
            }
            this._ringsScr = { sig, rings }
            return rings
        },
        // IE 2026 09 17 / ODOO-… (замечание Игоря: «связи с изгибом, максимально обходящим другие узлы и страны, которых он не
        // затрагивает»): из набора кривизн берётся та, у которой меньше штраф — пробные точки дуги внутри кружка чужого узла
        // и внутри территории, не принадлежащей концам связи; при равных штрафах остаётся привычный изгиб (0.22 в свою сторону).
        // Выключатели: настройка виджета map_link_avoid = false, настройка базы fe.ux.geoMapLinkAvoid = false.
        linkBend(o) {
            const mid = { x: (o.x1 + o.x2) / 2, y: (o.y1 + o.y2) / 2 }
            const at = (k) => ({ x: mid.x - o.uy * o.dist * k, y: mid.y + o.ux * o.dist * k, k })
            if (!o.avoid || (!o.nodes.length && !o.rings.length)) return at(0.22)
            const skipN = new Set([o.from, o.to])
            const skipC = new Set([o.fromCountry, o.toCountry].filter(Boolean))
            const SAMPLES = 11
            const cost = (k) => {
                const c = at(k)
                // цена крюка: длиннее дуга — дороже (иначе на плотной карте выбирается самый большой объезд) + привычный изгиб
                let s = Math.abs(Math.abs(k) - 0.22) * 4 + 1.33 * k * k * 25
                for (let i = 1; i < SAMPLES; i++) {
                    const t = i / SAMPLES, it = 1 - t
                    const x = it * it * o.x1 + 2 * it * t * c.x + t * t * o.x2
                    const y = it * it * o.y1 + 2 * it * t * c.y + t * t * o.y2
                    let np = 0
                    for (const n of o.nodes) {
                        if (skipN.has(n.key)) continue
                        const d = Math.hypot(n.x - x, n.y - y)
                        if (d < n.r) np += (n.r - d) * 0.5
                    }
                    s += Math.min(np, 6)   // скопление узлов не перевешивает всё остальное
                    for (const r of o.rings) {
                        if (skipC.has(r.key) || x < r.x0 || x > r.x1 || y < r.y0 || y > r.y1) continue
                        if (pointInRing(r.pts, x, y)) { s += 12; break }   // одной чужой территории на точку достаточно
                    }
                }
                return s
            }
            let best = null
            for (const k of [0.22, -0.22, 0.14, -0.14, 0.3, -0.3, 0.38, -0.38, 0.48, -0.48]) {
                const c = cost(k)
                if (!best || c < best.c - 0.001) best = { k, c }
                if (best.c <= 0.001) break   // обход без штрафа — дальше не ищем
            }
            return at(best ? best.k : 0.22)
        },
        // оверлей: кружки субъектов внутри территорий (спираль вокруг центроида, крупные ближе к центру) и кривые связей;
        // подпись страны — препятствие: кружок под ней перекрывался ожившей (pointer-events) подписью и не ловил мышь
        layoutOverlay() {
            const map = this._map, host = this.$refs.host
            if (!map || !host) { this.overlayPoints = []; this.overlayLinks = []; return }
            const hr = host.getBoundingClientRect()
            this.overlaySize = { w: Math.round(hr.width), h: Math.round(hr.height) }
            const centers = this._centers || new Map()
            const points = []
            const pd = this.pointsData
            const pointRings = new Map()   // IE 2026 09 15 (заказ Игоря: цепочка на карте): кольцо территории точки — предел разбегания муравьёв
            if (pd.size) {
                // IE 2026 09 15 (замечание Игоря): масштаб радиусов — по наибольшей величине глифа (итоги и месяцы), один на все месяцы;
                // размещение по place (не прыгает при смене месяца), рисуемые радиусы — значения текущего вида
                const maxSize = Math.max(...[...pd.values()].map(p => p.place))
                const capR = this.pointMaxR * 1.25
                const rOf = (s) => s > 0 ? Math.min(capR, POINT_MIN_R + (this.pointMaxR - POINT_MIN_R) * Math.sqrt(Math.max(0, s) / (maxSize || 1))) : 0
                const byCountry = new Map()
                for (const [k, p] of pd) { if (!byCountry.has(p.country)) byCountry.set(p.country, []); byCountry.get(p.country).push({ key: k, ...p }) }
                // IE 2026 09 15 (замечание Игоря): позиции точек — один раз на вид карты и набор точек (кэш), иначе бейдж-препятствие,
                // меняющийся по месяцам, сдвигал бы точку при смене месяца
                const placeSig = JSON.stringify([map.zoom, map.center && map.center.x, map.center && map.center.y, hr.width, hr.height, [...pd.entries()].map(([k, p]) => [k, p.country, p.place])])
                const cached = this._placeCache && this._placeCache.sig === placeSig ? this._placeCache.pos : null
                const posOut = new Map()
                for (const [country, list] of byCountry) {
                    const c = centers.get(country)
                    if (!c) continue
                    const ring = mainRing(c.feature.geometry)
                    list.sort((a, b) => b.place - a.place)
                    const placed = []
                    const step = this.pointMaxR * 1.15
                    const lbl = (this.labels || []).find(l => l.key === country && !l.hidden)   // IE 2026 09 14 / ODOO-… (замечание Игоря: бейджи, которым нет места): скрытый бейдж — не препятствие
                    const lw = lbl ? this.labelWidth(lbl) : 0, lh = 20
                    const hitsLabel = (x, y, r) => !!lbl && Math.abs(x - lbl.x) < lw / 2 + r + 2 && Math.abs(y - lbl.y) < lh / 2 + r + 2
                    for (const p of list) {
                        const r = rOf(p.place)
                        let best = cached ? (cached.get(p.key) || null) : null
                        for (let i = placed.length + 1, tries = 0; !best && tries < 80; i++, tries++) {
                            const ang = i * 2.399963, rad = step * Math.sqrt(i)
                            const x = c.x + rad * Math.cos(ang), y = c.y + rad * Math.sin(ang)
                            if (x < r || y < r || x > hr.width - r || y > hr.height - r) continue
                            if (hitsLabel(x, y, r)) continue
                            const g = map.convertBack(new Point(x, y))
                            if (ring && !pointInRing(ring, g.x, g.y)) continue
                            if (placed.some(q => Math.hypot(q.x - x, q.y - y) < q.rPlace + r + 2)) continue
                            best = { x, y }; break
                        }
                        if (!best) best = { x: c.x, y: c.y }
                        const mark = this.marks[p.key] || {}
                        const rr = (v) => Math.round(rOf(v) * 10) / 10
                        // IE 2026 09 16 (постановка Игоря): узел управляемого субъекта — сплошной круг = запас на КОНЕЦ (цвет = состояние на конец),
                        // пунктирный = запас на НАЧАЛО (цвет = состояние на начало); узел пополнения (поставщик) — красный при непокрытом объёме
                        const stv = this.stateView(p.key)
                        const cEnd = stateMeta(stv.se || stv.s), cStart = stateMeta(stv.s || stv.se)
                        const twoCircles = !!p.isNode && p.end > 0 && !p.emptyNow
                        const rEnd = twoCircles ? rr(p.end) : rr(p.size), rStart = twoCircles ? rr(p.size) : 0
                        // IE 2026 09 17 / ODOO-… (заказ Игоря): в этом месяце движения нет — пустой узел (контур) по максимуму периода
                        const fill = p.emptyNow ? 'none' : (mark.color || (p.isNode ? (cEnd ? cEnd.color : POINT_FILL) : (p.unc > 0 ? UNC_COLOR : POINT_FILL)))
                        const item = { key: p.key, x: Math.round(best.x), y: Math.round(best.y), emptyNow: !!p.emptyNow, r: rEnd, rStart, strokeStart: cStart ? cStart.color : '#37474f', rRing: rr(p.ring), rCore: rr(p.core), rPlace: Math.round(r * 10) / 10,
                            rMax: Math.max(rEnd, rStart, rr(p.ring), rr(p.core)), size: p.size, end: p.end, ring: p.ring, core: p.core, scatter: p.scatter, country, isNode: !!p.isNode,
                            title: this.titleOf(p.key, this.pointBinding), text: this.pointText(p), fill }
                        placed.push(item); points.push(item); posOut.set(p.key, { x: item.x, y: item.y })
                        if (ring) pointRings.set(p.key, ring)
                    }
                }
                this._placeCache = { sig: placeSig, pos: posOut }
            }
            this._pointRings = pointRings
            const pos = new Map(points.map(p => [p.key, p]))
            const links = []
            const ld = this.linksData
            if (ld.size) {
                // IE 2026 09 17 / ODOO-… (замечание Игоря): дуга связи обходит чужие узлы и территории, которых она не касается
                const avoidOn = this.attr?.map_link_avoid !== false && this.store.setting('fe.ux.geoMapLinkAvoid', true) !== false
                const ringsScr = avoidOn ? this.ringsScreen(map) : []
                const nodeObst = avoidOn ? points.map(p => ({ key: p.key, x: p.x, y: p.y, r: (p.rMax || p.r || 6) + 7 })) : []
                const maxV = Math.max(...[...ld.values()].map(l => (l.value || 0) + (l.unc || 0)))
                const mv = this.antMonthView   // IE 2026 09 16: непокрытый объём связи в месяце плеера (или в итогах)
                const endpoint = (k) => pos.get(k) || centers.get(k) || null
                const litKeys = new Set([...(this.hoverPoint ? [this.hoverPoint] : []), ...this.selectedPointKeys])
                for (const [key, l] of ld) {
                    const a = endpoint(l.from), b = endpoint(l.to)
                    if (!a || !b) continue
                    const ra = a.rPlace || a.r || 0, rb = b.rPlace || b.r || 0   // IE 2026 09 15: концы дуг — по радиусу размещения (не двигаются по месяцам)
                    const dx = b.x - a.x, dy = b.y - a.y, dist = Math.hypot(dx, dy) || 1
                    const ux = dx / dist, uy = dy / dist
                    const x1 = a.x + ux * (ra + 1), y1 = a.y + uy * (ra + 1)
                    const x2 = b.x - ux * (rb + 3), y2 = b.y - uy * (rb + 3)
                    // дуга: контрольная точка сдвинута перпендикулярно на четверть длины; IE 2026 09 17 / ODOO-… (замечание Игоря) —
                    // сторона и величина изгиба выбираются так, чтобы дуга меньше всего задевала чужие узлы и непричастные территории
                    const bend = this.linkBend({ x1, y1, x2, y2, ux, uy, dist, avoid: avoidOn, nodes: nodeObst, rings: ringsScr,
                        from: l.from, to: l.to, fromCountry: (pos.get(l.from) || {}).country || l.from, toCountry: (pos.get(l.to) || {}).country || l.to })
                    const mx = bend.x, my = bend.y
                    const wMax = ld.size > 60 ? 3.5 : 5   // много связей (десятки поставщиков) — тоньше
                    const w = 1 + wMax * Math.sqrt(Math.max(0, (l.value || 0) + (l.unc || 0)) / (maxV || 1))
                    const uncNow = mv ? ((l.months && l.months[mv]) ? l.months[mv].unc : 0) : (l.unc || 0)
                    // IE 2026 09 16 (заказ Игоря: подпись связи): точка дуги при t = 0.5, сдвинутая наружу по нормали — подпись не ложится под курсор
                    const cx = (x1 + 2 * mx + x2) / 4, cy = (y1 + 2 * my + y2) / 4
                    const nx = mx - (x1 + x2) / 2, ny = my - (y1 + y2) / 2, nl = Math.hypot(nx, ny) || 1
                    links.push({ key, x1, y1, mx, my, x2, y2, lx: Math.round(cx + nx / nl * 16), ly: Math.round(cy + ny / nl * 16), d: `M${x1.toFixed(1)},${y1.toFixed(1)} Q${mx.toFixed(1)},${my.toFixed(1)} ${x2.toFixed(1)},${y2.toFixed(1)}`,
                        w: Math.round(w * 10) / 10, value: l.value, unc: uncNow > 0, lit: litKeys.has(l.from) || litKeys.has(l.to), bendK: bend.k })
                }
            }
            // IE 2026 09 17 / ODOO-… (заказ Игоря): переключатели легенды — что показывать на карте
            this.overlayPoints = points.filter(p => (p.isNode ? this.show.nodes !== false : this.show.suppliers !== false))
            this.overlayLinks = this.show.links === false ? [] : links
            this.antGeomUpdate()   // IE 2026 09 15: геометрия дуг для муравьёв
        },
        // подпись точки: величины глифа текущего вида (IE 2026 09 15)
        pointText(p) {
            const parts = [this.fmtValue(p.size, this.pointSizeField) + (p.isNode && p.end > 0 ? ' → ' + this.fmtValue(p.end, this.fields.find(f => f.binding === this.pointEndBinding) || this.pointSizeField) : '')]   // IE 2026 09 16: начало → конец
            if (p.ring > 0) parts.push((this.pointRingTitle || 'ring') + ' ' + this.fmtValue(p.ring, this.pointRingField))
            if (p.core > 0) parts.push((this.pointCoreTitle || 'core') + ' ' + this.fmtValue(p.core, this.pointCoreField))
            return parts.join(' · ')
        },
        // ---- IE 2026 09 15 / ODOO-… (замечание Игоря): муравьиная логистика на карте — частицы по дугам связей помесячно; общие часы страницы ----
        // ---- IE 2026 09 16 (заказ Игоря): окно легенды карты — свободное, как у графика (ChartLegendPanel): портал = контейнер виджета
        // (родитель #WIDGET<id>), координаты — containing block портала, перетаскивание за шапку в пределах экрана
        legendEnsurePortal() {
            if (!this.legendPortal) this.legendPortal = document.getElementById('WIDGET' + (this.WIDGET?.id ?? ''))?.parentElement || null
            return this.legendPortal
        },
        legendContainingBlock() {
            let el = this.legendEnsurePortal()
            while (el && el !== document.body && el !== document.documentElement) {
                const cs = getComputedStyle(el)
                if (cs.position !== 'static' || cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none') return el
                el = el.parentElement
            }
            return null
        },
        legendToPortal(x, y) {
            const el = this.legendContainingBlock()
            if (!el) return { x: x + window.scrollX, y: y + window.scrollY }
            const r = el.getBoundingClientRect()
            return { x: x - r.left - el.clientLeft + el.scrollLeft, y: y - r.top - el.clientTop + el.scrollTop }
        },
        legendDefaultPos() {
            // IE 2026 09 16 (постановка Игоря): по правилам легенды графика — над виджетом у правого края (низ окна к верхней границе), нет места
            // сверху — справа от виджета у верхнего края, нет и там — внутри у правого верхнего угла карты под островком кнопок
            const wEl = document.getElementById('WIDGET' + (this.WIDGET?.id ?? ''))
            const r = (wEl || this.$refs.attr_container)?.getBoundingClientRect?.()
            if (!r || !r.width) return this.legendToPortal(Math.max(0, window.innerWidth - 300), 90)
            const pr = this.$refs.legendPanel?.getBoundingClientRect?.()
            const w = (pr && pr.width > 50) ? pr.width : 300, h = (pr && pr.height > 30) ? pr.height : 260
            const portal = this.legendEnsurePortal()?.getBoundingClientRect?.()
            const minTop = Math.max(0, portal ? portal.top : 0), gap = 4
            if (r.top - gap - h >= minTop) return this.legendToPortal(Math.max(0, r.right - w), r.top - gap - h)
            if (r.right + gap + w <= window.innerWidth) return this.legendToPortal(r.right + gap, Math.max(minTop, r.top))
            const host = this.$refs.attr_container?.getBoundingClientRect?.() || r
            return this.legendToPortal(Math.max(0, host.right - w - 8), host.top + 36)
        },
        legendPanelStyle() {
            this.legendEnsurePortal()
            if (!this.legendPos && !this._legendDefPos) {
                // размер окна известен после монтирования и меняется с содержимым — пока окно не перетаскивали, правый край держится
                // у правого края карты: положение по умолчанию пересчитывается по реальной ширине (ResizeObserver окна)
                this._legendDefPos = this.legendDefaultPos()
                this.$nextTick(() => {
                    const el = this.$refs.legendPanel
                    if (!el) return
                    const recalc = () => { if (!this.legendPos && this.$refs.legendPanel) { this._legendDefPos = this.legendDefaultPos(); this.legendDefTick = (this.legendDefTick || 0) + 1 } }
                    recalc()
                    if (typeof ResizeObserver !== 'undefined') {
                        if (this._legendRO) this._legendRO.disconnect()
                        this._legendRO = new ResizeObserver(() => recalc())
                        this._legendRO.observe(el)
                    }
                })
            }
            void this.legendDefTick
            const pos = this.legendPos || this._legendDefPos || (this._legendDefPos = this.legendDefaultPos())
            return { position: 'absolute', left: Math.max(0, pos.x) + 'px', top: Math.max(0, pos.y) + 'px', right: 'auto', bottom: 'auto', zIndex: 1000 }
        },
        legendPanelClosed() {
            if (this._legendRO) { this._legendRO.disconnect(); this._legendRO = null }
            if (!this.legendPos) this._legendDefPos = null
        },
        legendDragStart(e) {
            if (e.button !== 0) return
            if (e.target?.closest?.('.attr-geomap-panel-close')) return
            const panel = this.$refs.legendPanel
            if (!panel) return
            const p = panel.getBoundingClientRect()
            const ox = panel.offsetLeft - p.left, oy = panel.offsetTop - p.top
            this.legendPos = { x: panel.offsetLeft, y: panel.offsetTop }
            const drag = { dx: e.clientX - p.left, dy: e.clientY - p.top }
            const move = (ev) => {
                const vp = { x: Math.min(Math.max(0, ev.clientX - drag.dx), window.innerWidth - 60), y: Math.min(Math.max(0, ev.clientY - drag.dy), window.innerHeight - 30) }
                this.legendPos = { x: vp.x + ox, y: vp.y + oy }
            }
            const up = () => { document.removeEventListener('mousemove', move); document.removeEventListener('mouseup', up) }
            document.addEventListener('mousemove', move)
            document.addEventListener('mouseup', up)
            e.preventDefault()
        },
        // ---- IE 2026 09 16 (постановка Игоря: легенда карты) ----
        numericByName(param, def) { const b = (param && this.attr?.[param]) || def; return b && this.numericFields.some(f => f.binding === b) ? b : '' },
        fieldByName(param, def) { const b = (param && this.attr?.[param]) || def; return b && this.fields.some(f => f.binding === b) ? b : '' },
        // состояния точки текущего вида: месяц — его; Σ — начало первого месяца с данными, конец последнего
        stateView(key) {
            // состояние на конец без следующего месяца (край горизонта / без категории) — состояние на начало того же месяца
            const fx = (v) => v ? { s: v.s || v.se || '', se: v.se || v.s || '' } : { s: '', se: '' }
            if (this.nodesByCountry && this._cvStates && this._cvStates.has(key)) return this._cvStates.get(key)   // узел страны — худшее состояние
            const e = this.pointStates.get(key); if (!e) return { s: '', se: '' }
            const m = this.antMonthView
            if (m) return fx(e.months[m] || e.months.all)
            const ms = Object.keys(e.months).filter(x => x !== 'all').sort()
            if (!ms.length) return fx(e.months.all)
            const f = fx(e.months[ms[0]]), l = fx(e.months[ms[ms.length - 1]])
            return { s: f.s, se: l.se }
        },
        // итог страны: худшее состояние её узлов (управляемых субъектов)
        countryStateFor(key) {
            let s = '', se = ''
            for (const [k, p] of this.pointsData) if (p.country === key && p.isNode) { const st = this.stateView(k); s = worseState(s, st.s); se = worseState(se, st.se) }
            return { s, se }
        },
        // цвет страны в режиме состояния: месяц — состояние на начало месяца, Σ — на конец периода
        stateColorFor(key) { const st = this.countryStateFor(key); const v = this.antMonthView ? (st.s || st.se) : (st.se || st.s); return stateMeta(v) ? stateBg(v) : this.emptyColor },   // IE 2026 09 18: фон территории — цвет таблиц
        stateCategoriesPresent() {
            const seen = new Set()
            for (const [k, p] of this.pointsData) { if (!p.isNode) continue; const st = this.stateView(k); const v = this.antMonthView ? (st.s || st.se) : (st.se || st.s); if (stateMeta(v)) seen.add(v) }
            return [...seen].map(id => ({ id, ...STATE_META[id], title: stateTitle(id), color: stateBg(id) })).sort((a, b) => a.rank - b.rank)   // IE 2026 09 23 / ODOO-341407: i18n   // IE 2026 09 18: свотчи легенды — те же фоны, что у территорий
        },
        // IE 2026 09 17 / ODOO-… (заказ Игоря): свёртка узлов страны в один узел — меры складываются, DOS
        // средневзвешенно по весам *_w, состояние — худшее; берём значения ВИДА узла (pointValsView / stateView),
        // те же, по которым считается бейдж страны (countryVals), иначе DOS узла страны расходится с бейджем
        stateStyles_sync() {
            _stateStyles = this.store?.cssClassesByName || null
            _stateBgCache = {}
            this._stateBgCache = null
        },
                pointsByCountry(src) {
            const sumB = [...new Set([...this.pointSizeBindings, this.pointEndBinding, this.expiredBinding, this.inBinding, this.inUncBinding,
                this.outBinding, this.outUncBinding, this.antScatterBinding, this.antScatterUncBinding].filter(Boolean))]
            const wavgB = [this.dosBinding, this.dosEndBinding].filter(Boolean)
            const out = new Map(), acc = new Map(), vals = new Map(), states = new Map(), w = new Map()
            for (const [k, p] of src) {
                if (!p.isNode || !p.country) { out.set(k, p); continue }   // узлы пополнения (поставщики) — как есть
                const c = p.country
                let e = acc.get(c)
                if (!e) {
                    e = { country: c, isNode: true, byCountry: true, place: 0, size: 0, end: 0, ring: 0, core: 0, scatter: 0, scatterUnc: 0, unc: 0, emptyNow: true, vals: {} }
                    acc.set(c, e); vals.set(c, {}); states.set(c, { s: '', se: '' }); w.set(c, {})
                }
                for (const f of ['size', 'end', 'ring', 'core', 'scatter', 'scatterUnc', 'unc']) e[f] += (p[f] || 0)
                e.place = Math.max(e.place, p.place || 0)
                if (!p.emptyNow) e.emptyNow = false
                const v = this.pointValsView(k), st = this.stateView(k), a = vals.get(c), ww = w.get(c), sc = states.get(c)
                for (const b of sumB) if (Number.isFinite(v[b])) a[b] = (a[b] || 0) + v[b]
                for (const b of wavgB) {
                    if (!Number.isFinite(v[b])) continue
                    const q = Number.isFinite(v[b + '_w']) && v[b + '_w'] > 0 ? v[b + '_w'] : 1
                    a[b] = (a[b] || 0) + v[b] * q; ww[b] = (ww[b] || 0) + q
                }
                sc.s = worseState(sc.s, st.s); sc.se = worseState(sc.se, st.se)
            }
            for (const [c, e] of acc) {
                const a = vals.get(c), ww = w.get(c)
                for (const b of wavgB) if (ww[b]) { a[b] = a[b] / ww[b]; a[b + '_w'] = ww[b] }
                e.vals = a
                out.set(c, e)
            }
            this._cvVals = vals; this._cvStates = states   // значения / состояния узла страны для pointValsView и stateView
            return out
        },
        // значения узла текущего вида: месяц — его строка; Σ — начало из первого месяца, конец из последнего, потоки — итоги
        pointValsView(key) {
            if (this.nodesByCountry && this._cvVals && this._cvVals.has(key)) return this._cvVals.get(key)   // узел страны — агрегат
            const p = this.pointsAll.get(key); if (!p) return {}
            const m = this.antMonthView
            if (m) return (p.months[m] && p.months[m].vals) || {}
            const f = p.first ? p.months[p.first].vals : {}, l = p.last ? p.months[p.last].vals : {}
            const out = { ...(p.total.vals || {}) }
            for (const b of [this.pointSizeBindings[0], this.expiredBinding, this.dosBinding, this.dosBinding ? this.dosBinding + '_w' : '']) if (b && Number.isFinite(f[b])) out[b] = f[b]
            for (const b of [this.pointEndBinding, this.dosEndBinding, this.dosEndBinding ? this.dosEndBinding + '_w' : '']) if (b && Number.isFinite(l[b])) out[b] = l[b]
            return out
        },
        // строки блока наведения: запас на начало | просроченный · DOS начала | состояние · приход | непокрытый · расход | непокрытый ·
        // запас на конец · DOS конца | состояние; остальные меры — простыми строками (пара <мера>_uncovered — второй колонкой)
        // IE 2026 09 17 / ODOO-… (замечание Игоря): размер окна легенды не скачет при наведении на разные элементы —
        // держим достигнутый максимум, лишнее место остаётся пустым (сброс при закрытии окна и смене вкладки)
        legendBox_fix() {
            this.$nextTick(() => {
                const el = this.$refs.legendPanel
                if (el) stableBoxApply(el, this.legendBox, this.store.setting('fe.ux.legendStableSize', true) !== false)
            })
        },
        legendBox_reset() { stableBoxReset(this.legendBox, this.$refs.legendPanel) },
        // IE 2026 09 30 / ODOO-343341 (заказ Игоря: вкладки легенды карты на AttrTabPanel): вкладки [Node | Legend] окна легенды — AttrTabPanel (вкладки из props); выключатель fe.ux.mapLegendTabPanel (по умолчанию вкл.; false — прежние <span>)
        legendTabPanel_on() {
            try { return this.store.setting('fe.ux.mapLegendTabPanel', true) !== false } catch (e) { return true }
        },
        // вкладки — один и тот же массив, пока подписи те же (смена языка — новые подписи)
        legendTabs_list() {
            const a = this.t('Node'), b = this.t('Legend'), c = this._legendTabsList
            if (c && c[0].title === a && c[1].title === b) return c
            return (this._legendTabsList = [
                { name: 'node', html_id: 'map-legend-tab-node', title: a, help: { key: 'chart.map.legend.tabNode', state: () => this.legendTab } },
                { name: 'legend', html_id: 'map-legend-tab-legend', title: b, help: { key: 'chart.map.legend.tabLegend', state: () => this.legendTab } },
            ])
        },
        legendTabsBind() {
            if (!this.legendTabPanel_on()) return {}
            return { widget_id: this.WIDGET && this.WIDGET.id, localTabs: this.legendTabs_list(), localSelected: this.legendTab === 'node' ? 'node' : 'legend' }
        },
        legendTab_select(name) { if (name === 'node' || name === 'legend') this.legendTab = name },
        // IE 2026 09 17 / ODOO-… (заказ Игоря): показ слоёв карты — связи, узлы (управляемые субъекты),
        // узлы поставок (поставщики), выделение (раскраска) стран; состояние живёт в виджете на сеанс
        // IE 2026 09 18 (замечание Игоря): показ бейджей — при наведении виден только бейдж наведённого элемента
        labelShown(l) {
            const f = this.hoverFocus
            if (f) return f.kind === 'country' && f.key === l.key
            return (this.labelsOn && !l.hidden) || this.hoverKey === l.key || this.selectedKeys.has(l.key)
        },
        plabelShown(p) {
            const f = this.hoverFocus
            if (f) return f.kind === 'point' && f.key === p.key
            return this.hoverPoint === p.key || this.selectedPointKeys.has(p.key)
        },
        llabelShown(l) {
            const f = this.hoverFocus
            if (f) return f.kind === 'link' && f.key === l.key
            return this.hoverLink === l.key
        },
        showToggle(key) {
            this.show = { ...this.show, [key]: !this.show[key] }
            this.$nextTick(() => { this.layoutOverlay(); this.render(); this.legendBox_fix() })
        },
        legendRowsFromVals(vals, st) {
            const F = (b) => this.fields.find(f => f.binding === b)
            const has = (b) => !!b && Number.isFinite(vals[b])
            const fmt = (b) => this.fmtValue(vals[b], F(b))
            const title = (b) => (F(b)?.title || b)
            // IE 2026 09 23 / ODOO-341407: i18n
            const unc = (b) => b ? { title: this.t('uncovered'), text: has(b) ? fmt(b) : '—', cls: has(b) && vals[b] > 0 ? 'is-unc' : '' } : null
            // IE 2026 09 18 (заказ Игоря): фон ячейки / пилюли состояния — цвет таблиц, текст как в таблицах (на красном — белый)
            const pill = (v) => { const m = stateMeta(v); return m ? { title: this.t('state'), text: stateTitle(v), cls: 'is-state', style: { background: stateBg(v), color: stateFg(v) } } : null }
            const bg = (v) => { const m = stateMeta(v); return m ? { background: stateBg(v), color: stateFg(v) } : null }
            const sizeB = this.pointSizeBindings[0], endB = this.pointEndBinding, exB = this.expiredBinding, dB = this.dosBinding, deB = this.dosEndBinding
            const inB = this.inBinding, inU = this.inUncBinding, outB = this.outBinding, outU = this.outUncBinding
            const rows = [], used = new Set()
            const structured = this.stateBinding || endB || exB
            if (structured && has(sizeB)) { rows.push({ title: title(sizeB), text: fmt(sizeB), extra: has(exB) ? { title: this.t('expired'), text: fmt(exB), cls: vals[exB] > 0 ? 'is-expired' : '' } : null }); used.add(sizeB); if (exB) used.add(exB) }
            if (structured && has(dB)) { rows.push({ title: title(dB), text: fmt(dB), style: bg(st.s), extra: pill(st.s) }); used.add(dB) }
            if (structured && has(inB)) { rows.push({ title: title(inB), text: fmt(inB), extra: unc(inU) }); used.add(inB); if (inU) used.add(inU) }
            if (structured && has(outB)) { rows.push({ title: title(outB), text: fmt(outB), extra: unc(outU) }); used.add(outB); if (outU) used.add(outU) }
            if (has(endB)) { rows.push({ title: title(endB), text: fmt(endB) }); used.add(endB) }
            if (has(deB)) { rows.push({ title: title(deB), text: fmt(deB), style: bg(st.se), extra: pill(st.se) }); used.add(deB) }
            for (const f of this.numericFields) {
                const b = f.binding
                if (used.has(b) || /_w$/.test(b) || /_uncovered$/.test(b) || !has(b)) continue
                const u = this.numericFields.some(x => x.binding === b + '_uncovered') ? b + '_uncovered' : ''
                rows.push({ title: f.title || b, text: fmt(b), extra: u ? unc(u) : null }); used.add(b); if (u) used.add(u)
            }
            return rows
        },
        legendNodeInfo(key) {
            const p = this.pointsData.get(key); if (!p) return null
            return { kind: p.isNode ? this.t('Node') : this.t('Supplier'), title: this.titleOf(key, this.pointBinding), sub: p.country ? this.titleOf(p.country) : '', rows: this.legendRowsFromVals(this.pointValsView(key), this.stateView(key)) }
        },
        legendLinkInfo(key) {
            const l = this.linksData.get(key); if (!l) return null
            const m = this.antMonthView
            const mm = m ? ((l.months && l.months[m]) || { value: 0, unc: 0 }) : null
            const v = mm ? mm.value : l.value, u = mm ? mm.unc : l.unc
            const vf = this.fields.find(f => f.binding === this.linkValueBinding) || null
            const from = this.titleOf(l.from, this.linkFromBinding), to = this.titleOf(l.to, this.linkToBinding)
            const rows = [   // IE 2026 09 23 / ODOO-341407: i18n
                { title: this.t('From'), text: from },
                { title: this.t('To'), text: to },
                { title: (vf && vf.title) || this.t('Quantity'), text: this.fmtValue(v || 0, vf), extra: { title: this.t('uncovered'), text: this.fmtValue(u || 0, vf) || '—', cls: u > 0 ? 'is-unc' : '' } },
            ]
            return { kind: this.t('Link', null, 'graph'), title: from + ' → ' + to, sub: '', rows }   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)
        },
        legendCountryInfo(key) {
            const cv = this.countryVals(key); if (!cv) return null
            // IE 2026 09 23 / ODOO-341407: i18n
            if (!cv.n) return { kind: this.t('Country'), title: this.titleOf(key), sub: '', rows: this.legendRowsFromVals(cv.vals, { s: '', se: '' }) }
            return { kind: this.t('Country'), title: this.titleOf(key), sub: this.tn(cv.n, '{n} node', '{n} nodes') + ' · ' + this.t('Σ, stock cover weighted, state = worst'), rows: this.legendRowsFromVals(cv.vals, { s: cv.s, se: cv.se }) } // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        },
        hoverLinkSet(key) {
            if (this._hoverLinkTimer) { clearTimeout(this._hoverLinkTimer); this._hoverLinkTimer = null }
            if (key) { this.hoverLink = key; this.legendHover = { kind: 'link', key }; return }
            // уход со связи — с задержкой: курсор идёт к её подписи (чекбоксы / иконки)
            this._hoverLinkTimer = setTimeout(() => { this._hoverLinkTimer = null; this.hoverLink = null }, 350)
        },
        // ---- IE 2026 09 16 (заказ Игоря: подписи при наведении) ----
        // привязка точки по её ключу: узел витрины — первая привязка точек, конец связи (поставщик) — вторая
        pointBindingFor(key) {
            const p = this.pointsData.get(key)
            const pbs = this.pointBindings
            return (p && !p.isNode && pbs[1]) ? pbs[1] : (pbs[0] || '')
        },
        // виджет-селектор по виду элемента: страна / управляемый субъект / питающий субъект (настройки map_selector_*)
        selectorWidgetFor(kind) {
            const k = kind === 'country' ? 'map_selector_country' : (kind === 'supplier' ? 'map_selector_supplier' : 'map_selector_node')
            return String(this.attr?.[k] || '').trim()
        },
        kindOfPoint(key) { const p = this.pointsData.get(key); return p && !p.isNode ? 'supplier' : 'node' },
        // IE 2026 09 17 / ODOO-…: в режиме «узел на страну» ключ узла — ключ территории (справочник стран)
        pointIsCountryNode(key) { const p = this.pointsData.get(key); return !!(this.nodesByCountry && p && p.isNode && p.country === key) },
        // сегмент записи элемента — из строки словаря (DS-словари несут segment), иначе сегмент словаря; иконка — сегмента (как в форме чипса)
        recordSegmentFor(binding, key) {
            const seg = this.fields.find(f => f.binding === binding)?.relation_segment || ''
            const IS = seg ? this.store.itemsSource?.[seg] : null
            const row = IS?.ids?.[key] || (IS?.data || []).find(x => x && String(x.id) === String(key))
            return (row && typeof row.segment === 'string' && row.segment) ? row.segment : seg
        },
        openIconFor(binding, key) {
            const seg = this.recordSegmentFor(binding, key)
            const IS = this.store.itemsSource?.SEGMENTS
            const byId = (id) => IS?.ids?.[id] || (IS?.data || []).find(x => x?.id === id)
            let rec = seg ? byId(seg) : null, guard = 0
            while (rec && !(rec.pi || rec.doc?.pi) && rec.parent && guard++ < 6) rec = byId(rec.parent)
            const pi = String(rec?.pi || rec?.doc?.pi || '').trim()
            return pi ? pi.replace(/^pi\s+/, '') : 'pi-external-link'
        },
        openRecordFor(binding, key) {
            const seg = this.recordSegmentFor(binding, key)
            if (!seg || key == null || key === '') return
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, { command: 'widget_open', widget: 'widget-record', _activate: true, item: { id: String(key), segment: seg } })
        },
        // концы связи для подписи: {key, kind, binding, title, selected}
        linkEnds(lkey) {
            const l = this.linksData.get(lkey); if (!l) return []
            const mk = (k, kind) => { const b = this.pointBindingFor(k); return { key: k, kind, binding: b, title: this.titleOf(k, b), selected: this.selectedKeysFor(b).has(k), pkind: this.kindOfPoint(k) } }
            return [mk(l.from, 'from'), mk(l.to, 'to')]
        },
        badgeVal(v, field) { return this.fmtValue(v, field) },
        // IE 2026 09 23 / ODOO-341407: i18n: подписи бейджей
        badgePill(state) { const m = stateMeta(state); return m ? `<span class="attr-geomap-badge-state" style="background:${stateBg(state)};color:${stateFg(state)}">${stateTitle(state)}</span>` : '' },
        badgeUnc(v, field) { return v > 0 ? `<span class="attr-geomap-badge-unc">${this.t('uncovered')} ${this.fmtValue(v, field)}</span>` : '' },
        // страна: DOS на начало, состояние, продажи за период | непокрытые
        badgeCountry(key) {
            const cv = this.countryVals(key); if (!cv) return ''
            const F = (b) => this.fields.find(f => f.binding === b)
            const parts = []
            const dB = this.dosBinding, oB = this.outBinding, oU = this.outUncBinding
            if (dB && Number.isFinite(cv.vals[dB])) parts.push(`<span class="attr-geomap-badge-kv"><i>${(F(dB)?.title || this.t('Stock cover'))}</i> ${this.fmtValue(cv.vals[dB], F(dB))}</span>`) // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
            if (cv.s) parts.push(this.badgePill(cv.s))
            if (oB && Number.isFinite(cv.vals[oB])) parts.push(`<span class="attr-geomap-badge-kv"><i>${(F(oB)?.title || this.t('Sales'))}</i> ${this.fmtValue(cv.vals[oB], F(oB))}</span>`)
            if (oU && cv.vals[oU] > 0) parts.push(this.badgeUnc(cv.vals[oU], F(oU)))
            return parts.join('')
        },
        // узел: DOS и состояние на начало; поставщик: объём за период | непокрытый
        badgePoint(key) {
            const p = this.pointsData.get(key); if (!p) return ''
            const F = (b) => this.fields.find(f => f.binding === b)
            const parts = []
            if (p.isNode) {
                const v = this.pointValsView(key), st = this.stateView(key), dB = this.dosBinding
                if (dB && Number.isFinite(v[dB])) parts.push(`<span class="attr-geomap-badge-kv"><i>${(F(dB)?.title || this.t('Stock cover'))}</i> ${this.fmtValue(v[dB], F(dB))}</span>`) // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
                if (st.s) parts.push(this.badgePill(st.s))
            } else {
                const a = this.pointsAll.get(key), m = this.antMonthView
                const g = m ? (a && a.months[m]) : (a && a.total)   // объём за период (Σ — итог, не наибольший месяц)
                if (g) {
                    const sb = this.pointSizeBindings.find(b => !/_uncovered$/.test(b) && Number.isFinite(g.vals?.[b]) && g.vals[b] > 0) || this.pointSizeBindings.find(b => !/_uncovered$/.test(b))
                    const sf = this.fields.find(f => f.binding === sb) || this.pointSizeField
                    parts.push(`<span class="attr-geomap-badge-kv"><i>${(sf?.title || this.t('Flow'))}</i> ${this.fmtValue(g.size, sf)}</span>`)
                    if (g.unc > 0) parts.push(this.badgeUnc(g.unc, sf))
                }
            }
            return parts.join('')
        },
        badgeLink(lkey) {
            const l = this.linksData.get(lkey); if (!l) return ''
            const m = this.antMonthView
            const mm = m ? ((l.months && l.months[m]) || { value: 0, unc: 0 }) : null
            const v = mm ? mm.value : l.value, u = mm ? mm.unc : l.unc
            const vf = this.fields.find(f => f.binding === this.linkValueBinding) || null
            return `<span class="attr-geomap-badge-kv"><i>${(vf?.title || this.t('Flow'))}</i> ${this.fmtValue(v || 0, vf)}</span>` + (u > 0 ? this.badgeUnc(u, vf) : '')
        },
        // значения страны по правилам её узлов (суммы, DOS средневзвешенно, состояние — худшее) — для подписи и блока легенды
        countryVals(key) {
            const acc = {}, w = {}
            let s = '', se = '', n = 0
            const sumB = [this.pointSizeBindings[0], this.pointEndBinding, this.expiredBinding, this.inBinding, this.inUncBinding, this.outBinding, this.outUncBinding].filter(Boolean)
            const wavgB = [this.dosBinding, this.dosEndBinding].filter(Boolean)
            for (const [k, p] of this.pointsData) {
                if (p.country !== key || !p.isNode) continue
                n++
                const v = this.pointValsView(k), st = this.stateView(k)
                for (const b of sumB) if (Number.isFinite(v[b])) acc[b] = (acc[b] || 0) + v[b]
                for (const b of wavgB) if (Number.isFinite(v[b])) { const ww = Number.isFinite(v[b + '_w']) && v[b + '_w'] > 0 ? v[b + '_w'] : 1; acc[b] = (acc[b] || 0) + v[b] * ww; w[b] = (w[b] || 0) + ww }
                s = worseState(s, st.s); se = worseState(se, st.se)
            }
            for (const b of wavgB) if (w[b]) acc[b] = acc[b] / w[b]
            if (!n) { const vals = this.valuesAllView.get(key); return vals ? { vals, s: '', se: '', n: 0 } : null }
            return { vals: acc, s, se, n }
        },
        antsToggle(e) { this.store.set_viewParam(this.WIDGET, this.attr.name, 'map_ants', !!e.target.checked, this.attr); this.$nextTick(() => this.antEnsure()) },
        // IE 2026 09 16 (заказ Игоря): настройка «старт в Σ» — сохраняется с виджетом (viewParams), применяется и к живым часам страницы
        antsTotalToggle(e) {
            const on = !!e.target.checked
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'map_ants_total', on, this.attr)
            const c = this.antClockObj
            if (c && !!c.total !== on) antClockTotal(c)
        },
        antKey() { return `${this.WIDGET?.workspace || 'ws'}::${this.WIDGET?.page || 'page'}` },
        antUid() { return 'map:' + (this.WIDGET?.id ?? this.attr_id) },
        antDateBinding() { return this.antDateBindingC },
        // потоки: строки → (from|to) × месяц, объём — поле связи; геометрия — из overlayLinks (перекладывается в layoutOverlay)
        antFlowsBuild() {
            const fb = this.linkFromBinding, tb = this.linkToBinding, vb = this.linkValueBinding, db = this.antDateBinding(), ub = this.linkUncBinding
            const acc = new Map()
            for (const row of this.rows || []) {
                // IE 2026 09 16 (заказ Игоря): покрытый объём (months) и непокрытый (unc) — красные муравьи по той же дуге
                const v0 = +row?.[vb], u0 = ub ? +row?.[ub] : NaN
                const v = Number.isFinite(v0) && v0 > 0 ? v0 : 0, u = Number.isFinite(u0) ? u0 : 0   // непокрытый — со знаком, итог месяца ≥ 0 (ниже)
                if (!v && !u) continue
                const m = db ? (antMonthKey(row[db]) || String(row[db] || '').slice(0, 10) || 'all') : 'all'   // ключ месяца — YYYY-MM-01
                for (const f of rowKeys(row, fb)) for (const t of rowKeys(row, tb)) {
                    if (f === t) continue
                    const key = f + '|' + t
                    const a = acc.get(key) || { key, from: f, to: t, months: {}, unc: {} }
                    if (v) a.months[m] = (a.months[m] || 0) + v
                    if (u) a.unc[m] = (a.unc[m] || 0) + u
                    acc.set(key, a)
                }
            }
            const geom = this._antGeom = this._antGeom || {}
            const fromIdx = new Map(); let ci = 0
            const flows = []
            for (const a of acc.values()) {
                for (const m of Object.keys(a.unc)) if (!(a.unc[m] > 0)) delete a.unc[m]   // IE 2026 09 16: месяцы с непокрытым итогом ≤ 0 — без красных муравьёв
                if (!fromIdx.has(a.from)) fromIdx.set(a.from, ci++)
                const g = geom[a.key] = geom[a.key] || {}
                const allOnly = Object.keys(a.months).length === 1 && a.months.all !== undefined
                const pointAt = (t) => g.ok ? quadAt({ x: g.x1, y: g.y1 }, { x: g.mx, y: g.my }, { x: g.x2, y: g.y2 }, t) : null
                if (Object.keys(a.months).length) flows.push({ key: a.key, color: antHex(this.linkColor, fromIdx.get(a.from)), months: allOnly ? null : a.months, weight: allOnly ? a.months.all : 0, pointAt })
                // IE 2026 09 16 (заказ Игоря): непокрытый объём связи — красные муравьи (свой поток той же дуги, kind 'unc')
                if (Object.keys(a.unc).length) {
                    const allOnlyU = Object.keys(a.unc).length === 1 && a.unc.all !== undefined
                    flows.push({ key: a.key + '#unc', kind: 'unc', color: UNC_COLOR, months: allOnlyU ? null : a.unc, weight: allOnlyU ? a.unc.all : 0, pointAt })
                }
            }
            // IE 2026 09 15 (заказ Игоря: цепочка на карте): «разбегание» — продажи узла муравьями во все стороны в рамках его территории:
            // муравей получает направление (равномерно по кругу с разбросом) и длину пробега до границы территории, тает к концу пути
            const sb = this.antScatterBinding, ubS = this.antScatterUncBinding
            if (sb) {
                for (const [k, p] of this.pointsAll) {
                    // IE 2026 09 16 (заказ Игоря): разбегание делится на покрытую часть (обычный цвет) и непокрытую (красные муравьи)
                    const cov = (g0) => Math.max(0, (g0.scatter || 0) - (ubS ? (g0.scatterUnc || 0) : 0))
                    const months = {}, monthsU = {}; let any = false, anyU = false
                    for (const [m, g0] of Object.entries(p.months)) { const c = cov(g0); if (c > 0) { months[m] = c; any = true } if (ubS && g0.scatterUnc > 0) { monthsU[m] = g0.scatterUnc; anyU = true } }
                    const totalCov = cov(p.total), totalU = ubS ? (p.total.scatterUnc || 0) : 0
                    if (!any && !anyU && !(totalCov > 0) && !(totalU > 0)) continue
                    const g = geom['pt:' + k] = geom['pt:' + k] || {}
                    const init = (a, i, n) => { a.ang = (i / n) * Math.PI * 2 + (Math.random() - 0.5) * (Math.PI * 2 / Math.max(6, n)); a.len = this.antScatterLen(k, a.ang); a.speed = 0.75 + Math.random() * 0.5 }
                    const pointAt = (t, a) => g.ok ? { x: g.x + Math.cos(a.ang) * a.len * t, y: g.y + Math.sin(a.ang) * a.len * t } : null
                    const allOnly = !any && !anyU
                    if (any || totalCov > 0) flows.push({ key: 'pt:' + k, kind: 'scatter', fade: true, color: SCATTER_COLOR, months: allOnly ? null : months, weight: allOnly ? totalCov : 0, init, pointAt })
                    if (anyU || totalU > 0) flows.push({ key: 'pt:' + k + '#unc', kind: 'scatter-unc', fade: true, color: UNC_COLOR, months: allOnly ? null : monthsU, weight: allOnly ? totalU : 0, init, pointAt })
                }
            }
            this._antMonths = [...new Set([].concat(...flows.map(f => f.months ? Object.keys(f.months) : [])))].sort()
            if (!this._antRunner) this._antRunner = new AntRunner()
            this._antRunner.setFlows(flows); this._antRunner.reset()
            if (!this.antClockObj) this.antClockObj = markRaw(antClock(this.antKey()))
            antClockStartMode(this.antClockObj, this.antsTotalStart)   // IE 2026 09 16 (заказ Игоря): по умолчанию Σ — итоги за период
            antClockJoin(this.antClockObj, this.antUid(), this._antMonths)
            this._antSig = ''
        },
        antGeomUpdate() {
            const geom = this._antGeom = this._antGeom || {}
            for (const g of Object.values(geom)) g.ok = false
            for (const l of this.overlayLinks) { const g = geom[l.key] = geom[l.key] || {}; Object.assign(g, { x1: l.x1, y1: l.y1, mx: l.mx, my: l.my, x2: l.x2, y2: l.y2, ok: true }) }
            for (const p of this.overlayPoints) { const g = geom['pt:' + p.key] = geom['pt:' + p.key] || {}; if (g.x !== p.x || g.y !== p.y) g.lens = null; Object.assign(g, { x: p.x, y: p.y, ok: true }) }   // IE 2026 09 15: центры разбегания
            this.antEnsure()
        },
        // IE 2026 09 15 (заказ Игоря: цепочка на карте): длина пробега муравья продаж от точки в направлении ang — до границы территории
        // точки (кольцо в гео-координатах, проверка через map.convertBack), кэш по 36 секторам; вне территории / без кольца — короткий пробег
        antScatterLen(key, ang) {
            const g = (this._antGeom || {})['pt:' + key], map = this._map
            if (!g || !g.ok || !map) return 30
            const lens = g.lens || (g.lens = new Array(36)), bi = ((Math.round(ang / (Math.PI * 2) * 36) % 36) + 36) % 36
            if (lens[bi] != null) return lens[bi]
            const ring = (this._pointRings || new Map()).get(key)
            const W = this.overlaySize.w, H = this.overlaySize.h
            const inside = (d) => {
                const x = g.x + Math.cos(ang) * d, y = g.y + Math.sin(ang) * d
                if (x < 2 || y < 2 || x > W - 2 || y > H - 2) return false
                if (!ring) return d < 60
                const q = map.convertBack(new Point(x, y))
                return pointInRing(ring, q.x, q.y)
            }
            const far = Math.max(40, Math.min(420, Math.hypot(W, H) / 2))
            let len = 22
            if (inside(6)) {
                const step = far / 24
                let d = 6, last = 6
                while (d <= far && inside(d)) { last = d; d += step }   // первый выход за границу
                let lo = last, hi = Math.min(far, d)
                for (let i = 0; i < 7; i++) { const mid = (lo + hi) / 2; if (inside(mid)) lo = mid; else hi = mid }
                len = Math.max(14, lo - 3)
            }
            lens[bi] = len
            return len
        },
        antEnsure() {
            if (!this.antsOn || !this.antsActive) { this.antStop(); return }
            if (!this._antRunner || this._antRowsSig !== this.antFlowsKey) { this._antRowsSig = this.antFlowsKey; this.antFlowsBuild() }   // IE 2026 09 15: месячный вид потоки не пересобирает
            if (!this._antRaf) { this._antLast = performance.now(); this._antRaf = requestAnimationFrame(this.antFrame) }
        },
        antStop() {
            if (this._antRaf) { cancelAnimationFrame(this._antRaf); this._antRaf = null }
            if (this.antClockObj) { antClockLeave(this.antClockObj, this.antUid()); this.antClockObj = null }
            this._antRunner = null; this._antRowsSig = null
            if (this.antMonthView) this.antMonthView = ''   // IE 2026 09 15: без муравьёв — итоги
        },
        antFrame(now) {
            this._antRaf = requestAnimationFrame(this.antFrame)
            const cv = this.$refs.antCanvas, r = this._antRunner, c = this.antClockObj
            if (!cv || !r || !c) return
            const dt = Math.min(100, now - (this._antLast || now)); this._antLast = now
            antClockSyncPeriod(c, this.store, this.WIDGET)   // IE 2026 09 15 (заказ Игоря): шкала времени — по чипсу периода стола
            antClockTick(c, this.antUid(), dt)
            const allOnly = !(this._antMonths || []).length
            const m = allOnly ? 'all' : c.month
            // IE 2026 09 15 (замечание Игоря, вечер): пауза при одном месяце шкалы (чипс периода = месяц) — снимок начала движения:
            // свежая партия от узлов, замирает на середине пути, без цикла; пауза при интервале — как раньше (выпущенные доходят)
            const single = !c.playing && c.timeline.length === 1
            if (c.playing) { r.freezeLap = null; r.spawn(c.month || 'all', c.lap); r.step(dt, c.speed) }   // партия на каждый месяц часов; потоки без дат — по весу
            else if (single) { if (r.freezeLap !== c.lap) r.freezeBatch(c.month || 'all', c.lap); r.stepTo(dt, c.speed, 0.5) }
            else r.step(dt, c.speed)
            const ctx = cv.getContext('2d'); ctx.setTransform(this.antDpr, 0, 0, this.antDpr, 0, 0); ctx.clearRect(0, 0, this.overlaySize.w, this.overlaySize.h)
            r.draw(ctx)
            const sig = antClockSig(c)
            if (sig !== this._antSig) {
                this._antSig = sig; this.antTick++; this.antMonth = allOnly ? 'all' : (c.month || '')
                // IE 2026 09 16 (заказ Игоря): режим Σ — объёмы за все месяцы шкалы (без шкалы — партия «all»)
                const months = c.total ? (c.timeline.length ? c.timeline : ['all']) : [m]
                const vol = (kind) => months.reduce((s, mm) => s + r.volume(mm, kind), 0)
                const v = vol('link'), vs = vol('scatter'), vf = this.fields.find(f => f.binding === this.linkValueBinding)
                const vu = vol('unc'), vsu = vol('scatter-unc')   // IE 2026 09 16: непокрытые объёмы связей и разбегания
                const parts = []
                if (v || vu) parts.push((c.total ? 'Σ in ' : 'in ') + this.fmtValue(v, vf || null, true) + (vu ? ' (uncovered ' + this.fmtValue(vu, vf || null, true) + ')' : ''))
                if (vs || vsu) parts.push((this.antScatterTitle || 'sales').toLowerCase() + ' ' + this.fmtValue(vs + vsu, this.antScatterField || null, true) + (vsu ? ' (uncovered ' + this.fmtValue(vsu, this.antScatterField || null, true) + ')' : ''))
                this.antStats = parts.join(' · ')
                // IE 2026 09 15 (замечание Игоря): территории и точки — по месяцу часов (перерисовка карты значениями месяца);
                // IE 2026 09 16 (заказ Игоря): режим Σ — итоги всех месяцев (агрегат каждой меры: Sum / Avg / WAvg по Basis)
                const mv = (allOnly || c.total) ? '' : (c.month || '')
                if (mv !== this.antMonthView) this.antMonthView = mv
            }
        },
        // ---- наведение и отбор (селектор стола) ----
        // наведение считается по цели mousemove контейнера (mouseenter на SVG-кружке не срабатывал при «прыжке» курсора).
        // Уход с кружка / подписи снимает наведение с задержкой (замечание Игоря): курсор должен успеть дойти до чекбокса
        // подписи, не «пролетая» её через зазор, где подпись уже пропала
        // // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
        // правая кнопка по узлу (кружок точки .attr-geomap-pt или её подпись .attr-geomap-plabel) — окно легенды, вкладка Node с этим узлом: узел — наведённый
        // элемент (hoverPointSet, как наведение), закрытое окно открывается (как кнопка легенды). Территории, связи, пустое место — не перехватывать (меню виджета).
        // Телефон / выключатель fe.ux.contextMenuActions = false — как до правки. Счётчик window.ctxMenuActions.mapNode
        ctxMenu_mapNode(e) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
            if (!ctxMenu_allowed(this.store, e)) return
            const circ = e.target?.closest?.('.attr-geomap-pt'), plbl = circ ? null : e.target?.closest?.('.attr-geomap-plabel')
            const key = (circ ? circ.dataset.key : plbl?.dataset.pkey) || null
            if (!key) return
            e.preventDefault()
            this.hoverPointSet(key)
            this.legendTab = 'node'
            this.legendPanelVisible = true
            ctxMenu_count('mapNode')
        },
        hoverPointSet(key) {
            if (this._hoverPointTimer) { clearTimeout(this._hoverPointTimer); this._hoverPointTimer = null }
            if (key) { this.hoverPoint = key; this.legendHover = { kind: 'node', key }; return }   // IE 2026 09 16: блок наведения легенды
            if (!this.hoverPoint) return
            this._hoverPointTimer = setTimeout(() => { this._hoverPointTimer = null; this.hoverPoint = null }, 350)
        },
        hoverKeySet(key) {
            if (this._hoverKeyTimer) { clearTimeout(this._hoverKeyTimer); this._hoverKeyTimer = null }
            if (key) { this.hoverKey = key; return }
            if (!this.hoverKey) return
            this._hoverKeyTimer = setTimeout(() => { this._hoverKeyTimer = null; this.hoverKey = null }, 350)
        },
        onHostLeave() {
            if (this._hoverPointTimer) { clearTimeout(this._hoverPointTimer); this._hoverPointTimer = null }
            if (this._hoverKeyTimer) { clearTimeout(this._hoverKeyTimer); this._hoverKeyTimer = null }
            this.hoverKey = null; this.hoverPoint = null
        },
        onHostMove(e) {
            const llbl = e.target?.closest?.('.attr-geomap-llabel')   // IE 2026 09 16: подпись связи — связь под курсором остаётся
            if (llbl) { this.hoverLinkSet(llbl.dataset.lkey || null); return }
            const circ = e.target?.closest?.('.attr-geomap-pt')   // IE 2026 09 15: глиф точки — группа кругов
            const plbl = e.target?.closest?.('.attr-geomap-plabel')
            if (circ || plbl) { this.hoverPointSet((circ ? circ.dataset.key : plbl.dataset.pkey) || null); return }
            this.hoverPointSet(null)
            const lbl = e.target?.closest?.('.attr-geomap-label')
            if (lbl) { if (lbl.dataset.key) { this.hoverKeySet(lbl.dataset.key); this.legendHover = { kind: 'country', key: lbl.dataset.key } } return }   // IE 2026 09 16: блок легенды — страна
            const overLink = !!e.target?.closest?.('.attr-geomap-link')   // IE 2026 09 16: связь ловит мышь — страна под ней всё равно наведена
            if (!overLink && !e.target?.closest?.('.attr-geomap-host')) { this.hoverKeySet(null); return }   // кнопки, легенда, панель, оверлей
            const map = this._map
            if (!map) return
            try {
                const ht = map.hitTest(e)
                const key = ht?.item?.__key ?? null
                this.hoverKeySet(key)
                if (key && !e.target?.closest?.('.attr-geomap-link')) this.legendHover = { kind: 'country', key }   // IE 2026 09 16: блок легенды — страна под курсором
            } catch (err) { this.hoverKeySet(null) }
        },
        onLabelClick(e, key) {
            if (!key) return
            if (e?.target?.closest?.('.attr-geomap-open')) return   // IE 2026 09 16: иконка открытия записи — не отбор
            this.toggleSelectFor(this.geoBinding, key, !!e.altKey, 'country')
        },
        onPointClick(e, key) {
            if (!key || !this.pointBinding) return
            if (e?.target?.closest?.('.attr-geomap-open')) return   // IE 2026 09 16: иконка открытия записи — не отбор
            this.toggleSelectFor(this.pointBindingFor(key), key, !!e.altKey, this.kindOfPoint(key))   // IE 2026 09 16 (заказ Игоря): поставщик — своя привязка и свой селектор
        },
        selectionRowFor(binding) {
            const WHERE = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE
            if (!Array.isArray(WHERE) || !binding) return null
            return WHERE.find(w => w && (w.leftValue || {}).value === binding && (w.condition || 'in') === 'in' && w.type !== 'selector_map_dimensions') || null
        },
        // IE 2026 09 16 (заказ Игоря): строка чипса виджета-селектора (настройки map_selector_*) и её ключи
        selectorRowFor(widgetId) {
            const WHERE = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE
            if (!Array.isArray(WHERE) || !widgetId) return null
            return WHERE.find(w => w && w.widget === widgetId && (w.condition || 'in') === 'in' && w.type !== 'selector_map_dimensions' && w.leftValue) || null
        },
        selectedKeysRow(row) {
            const out = new Set()
            if (!row || !row.use) return out
            for (const a of (row.attrs || [])) { const v = a?.rightValue?.value; if (v && typeof v !== 'object' && a.use !== false) out.add(String(v)) }
            return out
        },
        selectedKeysFor(binding) {
            const row = this.selectionRowFor(binding)
            const out = new Set()
            if (!row || !row.use) return out
            for (const a of (row.attrs || [])) {
                const v = a?.rightValue?.value
                if (v && typeof v !== 'object' && a.use !== false) out.add(String(v))
            }
            return out
        },
        clearSelection() {
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · дефект (defects-found.md, charts/maps): «clear» снимал
            // только geoBinding + pointBindings[0] — счётчик «N selected» (selectedKeys/selectedPointKeys) сверх этого суммирует
            // pointBindings[1] (вторая привязка точек — поставщики) и строки виджетов-селекторов country/node/supplier
            // (selectorRowFor(selectorWidgetFor(kind))) — они оставались выбранными и после «clear». Снимаем всё, что считает счётчик.
            let changed = false
            const rows = []
            for (const b of [this.geoBinding, ...this.pointBindings]) { const row = this.selectionRowFor(b); if (row) rows.push(row) }
            for (const kind of ['country', 'node', 'supplier']) { const row = this.selectorRowFor(this.selectorWidgetFor(kind)); if (row) rows.push(row) }
            for (const row of rows) {
                if (row && (row.use || (row.attrs || []).length)) { row.attrs = []; row.use = false; changed = true }
            }
            if (changed) this.store.workspace_applySelector(this.WIDGET.workspace, this.WIDGET.page, this.WIDGET)
        },
        // клик по чекбоксу: добавить/снять значение в чипсе стола по полю; Alt — оставить только его. Запись стола не сохраняется:
        // чипс живёт в params.WHERE сессии, как отбор из списка-селектора (workspace_applySelector)
        toggleSelectFor(binding, key, exclusive, kind = '') {
            const WORKSPACE = this.store.WORKSPACES?.[this.WIDGET?.workspace]
            const params = WORKSPACE?.record?.doc?.params
            if (!params || !binding) return
            const WHERE = params.WHERE = params.WHERE || []
            // IE 2026 09 16 (заказ Игоря): чипс принадлежит виджету-селектору по виду элемента (настройки map_selector_country / _node / _supplier):
            // строка WHERE этого селектора (его поле), иначе строка поля карты (создаётся с widget = селектор или сам виджет)
            const selWidget = this.selectorWidgetFor(kind || (binding === this.geoBinding ? 'country' : this.kindOfPoint(key)))
            let row = this.selectorRowFor(selWidget) || this.selectionRowFor(binding)
            const field = this.fields.find(f => f.binding === binding) || {}
            if (!row) {
                row = {
                    use: true, attr_type: 'AttrChipWhere', condition: 'in',
                    widget: selWidget || this.WIDGET.widget, 'widget-segment': this.WIDGET.record?.segment || 'WIDGET-LIST',
                    leftValue: { value: binding, valueStr: field.title || binding, attr_type: 'AttrLink', component: 'AttrLink', valueStr_fix: true, relation_segment: '' },
                    rightValue: { pi: 'pi pi-arrow-right', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: field.relation_segment || '' },
                    attrs: [],
                }
                WHERE.push(row)
            }
            if (selWidget && !row.widget) row.widget = selWidget
            const seg = row.rightValue?.relation_segment || field.relation_segment || ''
            const current = [...this.selectedKeysRow(row)]
            let next
            if (exclusive) next = (current.length === 1 && current[0] === key) ? [] : [key]
            else next = current.includes(key) ? current.filter(k => k !== key) : [...current, key]
            const mkRow = (k) => ({
                use: true,
                leftValue: { pi: '', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', hideTitle: true, relation_segment: '' },
                rightValue: { pi: 'pi pi-arrow-right', value: k, valueStr: this.titleOf(k, binding), attr_type: 'AttrLink', component: 'AttrLink', relation_segment: seg },
            })
            // прежний порядок сохраняем (строки чипса с теми же id), новые — в конец
            const kept = (row.attrs || []).filter(a => a?.rightValue?.value && next.includes(String(a.rightValue.value)))
            const keptIds = new Set(kept.map(a => String(a.rightValue.value)))
            row.attrs = [...kept, ...next.filter(k => !keptIds.has(k)).map(mkRow)]
            row.use = row.attrs.length > 0
            this.store.workspace_applySelector(this.WIDGET.workspace, this.WIDGET.page, this.WIDGET)
        },
    },
    watch: {
        // IE 2026 09 17 / ODOO-… (замечание Игоря): наведение сменилось — пересчитать «пол» размера окна легенды
        legendHoverInfo() { this.legendBox_fix() },
        // IE 2026 09 18 / ODOO-… (заказ Игоря: именованные стили): реестр стилей пришёл / обновился — цвета категорий запаса заново
        stateStylesEpoch() { this.stateStyles_sync(); this.render() },
        legendTab() { this.legendBox_reset(); this.legendBox_fix() },
        legendPanelVisible(v) { if (!v) { this.legendBox_reset(); this.legendPanelClosed() } else this.legendBox_fix() },   // IE 2026 09 16 (заказ Игоря): свободное окно легенды
        antsOn() { this.$nextTick(() => this.antEnsure()) },   // IE 2026 09 15: муравьи по связям
        renderKey() { this.render() },
        legendOn() { this.$nextTick(() => { this.attrResize(); this.legendIslandMeasure() }) },
        scaleInfo() { this.$nextTick(() => this.legendIslandMeasure()) },   // IE 2026 09 15: легенда появилась / исчезла
        labelsOn() { this.placeLabels() },
        // отбор: перерисовать контуры (без пересчёта зума) и подсветку связей
        selectedSig() {
            this._selected = new Set(this.selectedKeys)
            if (this._map) this._map.invalidate(true)
        },
        hoverPoint() { if (this.overlayLinks.length) this.layoutOverlay() },
        // сброс активной меры, если настройка виджета сменилась
        'attr.map_value_binding'() { this.activeBinding = '' },
    },
}
</script>

<style scoped>
.attr-geo-map {
    position: relative;
}
.attr-geomap-cog {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 10;
}
.attr-geomap-legend-btn {
    position: absolute;
    top: 4px;
    right: 34px;
    z-index: 10;
}
.attr-geomap-btn-on {
    background: rgba(47, 59, 82, 0.12);
    border-radius: 4px;
}
.attr-geomap-panel {
    position: absolute;   /* IE 2026 09 16 (заказ Игоря): свободное окно — left/top inline (legendPanelStyle), перетаскивание за шапку */
    z-index: 20;
    user-select: none;
    max-width: 380px;   /* IE 2026 09 16: вне карты ширину никто не ограничивает — длинные описания переносятся */
    min-width: 220px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid #2f3b52;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    padding: 6px 8px 8px;
    font-size: 12px;
    color: #1f2937;
}
.attr-geomap-panel-head {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    margin-bottom: 4px;
    cursor: move;   /* IE 2026 09 16 (заказ Игоря): окно перетаскивается за шапку */
}
.attr-geomap-panel-close {
    cursor: pointer;
    color: #c62828;
}
.attr-geomap-panel-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 2px;
    cursor: pointer;
    border-radius: 4px;
}
.attr-geomap-panel-row:hover {
    background: rgba(47, 59, 82, 0.08);
}
.attr-geomap-panel-row.is-active .attr-geomap-panel-title {
    font-weight: 600;
}
.attr-geomap-panel-bar {
    display: inline-block;
    width: 48px;
    height: 8px;
    border-radius: 4px;
    margin-left: auto;
    border: 1px solid #2f3b52;
}
.attr-geomap-panel-foot {
    display: flex;
    align-items: center;
    flex-wrap: wrap;   /* IE 2026 09 16: описания узлов / связей — с переносом в окне ограниченной ширины */
    gap: 8px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #e5e7eb;
    color: #4b5563;
}
.attr-geomap-panel-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #3949ab;
    border: 1px solid #1a237e;
}
.attr-geomap-panel-line {
    display: inline-block;
    width: 18px;
    height: 3px;
    border-radius: 2px;
}
.attr-geomap-host {
    width: 100%;
    height: 300px;
    border-radius: 10px;
    overflow: hidden;
}
.attr-geomap-empty {
    position: absolute;
    left: 0; right: 0; top: 40%;
    text-align: center;
    color: #6b7280;
    z-index: 5;
    pointer-events: none;
}
.attr-geomap-overlay {
    position: absolute;
    left: 0; top: 0;
    pointer-events: none;
    overflow: visible;
}
.attr-geomap-link {
    opacity: 0.8;
    stroke-linecap: round;
    pointer-events: stroke;   /* IE 2026 09 16 (постановка Игоря): наведение на связь — блок в легенде */
    cursor: pointer;
}
.attr-geomap-link.is-hover { opacity: 1; filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.45)); }
.attr-geomap-point-start { pointer-events: none; stroke-width: 1.5; }
/* IE 2026 09 16 (постановка Игоря): блок наведения окна легенды */
.attr-geomap-panel-hover { margin-top: 6px; padding-top: 6px; border-top: 1px solid #e5e7eb; }
/* IE 2026 09 16 / ODOO-5800 (заказ Игоря): вкладки легенды Node | Legend */
.attr-geomap-panel-tabs { display: flex; gap: 2px; margin: 0 0 4px; border-bottom: 1px solid #e5e7eb; }
.attr-geomap-panel-tab { padding: 2px 8px 3px; cursor: pointer; color: #4b5563; border-bottom: 2px solid transparent; margin-bottom: -1px; }
.attr-geomap-panel-tab:hover { color: #1f2937; }
.attr-geomap-panel-tab.is-on { color: #1f2937; font-weight: 600; border-bottom-color: #2f3b52; }
.attr-geomap-panel-tabbed .attr-geomap-panel-hover { margin-top: 0; padding-top: 2px; border-top: none; }
.attr-geomap-panel-hint { color: #6b7280; padding: 6px 2px; }
.attr-geomap-panel-hover-head { display: flex; align-items: baseline; gap: 6px; margin-bottom: 4px; min-width: 0; }
.attr-geomap-panel-hover-kind { font-size: 10px; letter-spacing: 0.06em; text-transform: uppercase; color: #6b7280; flex: none; }
.attr-geomap-panel-hover-title { max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.attr-geomap-panel-hover-sub { color: #6b7280; font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.attr-geomap-hover-table { border-collapse: collapse; width: 100%; }
.attr-geomap-hover-table td { padding: 2px 4px; white-space: nowrap; }
.attr-geomap-hover-name { color: #4b5563; max-width: 150px; overflow: hidden; text-overflow: ellipsis; }
.attr-geomap-hover-val { text-align: right; font-weight: 600; border-radius: 4px; }
.attr-geomap-hover-extra { text-align: right; border-radius: 4px; color: #4b5563; }
.attr-geomap-hover-xl { font-size: 10px; color: #6b7280; margin-right: 3px; }
.attr-geomap-hover-extra.is-unc { background: rgba(198, 40, 40, 0.16); color: #b71c1c; font-weight: 600; }
.attr-geomap-hover-extra.is-expired { background: rgba(198, 40, 40, 0.10); color: #b71c1c; }
.attr-geomap-hover-extra.is-state { font-weight: 600; }
.attr-geomap-legend-cat { display: inline-flex; align-items: center; gap: 3px; margin-left: 6px; font-size: 11px; white-space: nowrap; }
.attr-geomap-legend-swatch { display: inline-block; width: 10px; height: 10px; border-radius: 2px; border: 1px solid rgba(0, 0, 0, 0.15); }
.attr-geomap-link.is-dim {
    opacity: 0.12;
}
.attr-geomap-link.is-lit {
    opacity: 1;
}
/* IE 2026 09 15 (замечание Игоря): глиф точки — группа кругов (диск, кольцо, красное ядро); радиусы плавно по месяцам */
.attr-geomap-pt {
    pointer-events: auto;
    cursor: pointer;
}
.attr-geomap-pt circle { transition: r 0.5s ease, fill-opacity 0.15s; }
.attr-geomap-pt.is-dim .attr-geomap-point {
    fill-opacity: 0.22;
    stroke-opacity: 0.35;
}
.attr-geomap-pt.is-dim .attr-geomap-point-ring, .attr-geomap-pt.is-dim .attr-geomap-point-core { opacity: 0.3; }
.attr-geomap-pt.is-lit .attr-geomap-point {
    fill-opacity: 1;
    stroke-width: 2;
}
.attr-geomap-point {
    fill-opacity: 0.78;
    stroke: #1a237e;
    stroke-width: 1.2;
}
.attr-geomap-pt.is-hover .attr-geomap-point {
    fill-opacity: 1;
}
.attr-geomap-pt.is-selected .attr-geomap-point {
    stroke-width: 3;
}
/* IE 2026 09 17 / ODOO-… (заказ Игоря): в этом месяце движения из узла нет — пустой круг по максимуму периода */
.attr-geomap-point.is-empty { fill: none; stroke-dasharray: 3 2; stroke-opacity: .55; }
.attr-geomap-pt.is-hover .attr-geomap-point.is-empty, .attr-geomap-pt.is-selected .attr-geomap-point.is-empty { stroke-opacity: 1; }
/* IE 2026 09 17 / ODOO-… (заказ Игоря): переключатели слоёв в легенде */
.attr-geomap-panel-show { margin: 2px 0 4px; padding-bottom: 4px; border-bottom: 1px dashed #d7dbe6; }
.attr-geomap-point-ring { fill: rgba(255, 255, 255, 0.55); stroke: #2f3b52; stroke-width: 1.4; }
.attr-geomap-point-core { fill: #d9534f; stroke: #b23b37; stroke-width: 1; }
.attr-geomap-labels {
    position: absolute;
    left: 0; top: 0;
    pointer-events: none;
}
.attr-geomap-label {
    position: absolute;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
    color: #1f2937;
    background: rgba(255, 255, 255, 0.82);
    border: 1px solid #2f3b52;
    border-radius: 10px;
    padding: 1px 6px;
    line-height: 16px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
}
/* только наведённая / отобранная подпись ловит мышь: клик по чекбоксу — отбор */
.attr-geomap-label.is-hover,
.attr-geomap-label.is-selected {
    pointer-events: auto;
    cursor: pointer;
}
.attr-geomap-label.is-hover { z-index: 4; }   /* IE 2026 09 14 / ODOO-… (замечание Игоря: бейджи, которым нет места): показанный по наведению — поверх соседних */
.attr-geomap-label.is-selected {
    border-color: #1a237e;
    box-shadow: 0 0 0 2px rgba(26, 35, 126, 0.25);
}
.attr-geomap-label:not(.is-text) {
    padding: 1px 4px;
}
.attr-geomap-plabel {
    font-weight: 500;
    z-index: 3;
}
.attr-geomap-label-name { font-weight: 500; color: #374151; }   /* IE 2026 09 14 / ODOO-5800: название территории в бейдже при наведении */
.attr-geomap-check {
    font-size: 13px;
    color: #1a237e;
}
/* IE 2026 09 16 (заказ Игоря: подписи при наведении): иконка записи, показатели, пилюля состояния, непокрытый — красным */
.attr-geomap-open { font-size: 12px; color: #4b5563; cursor: pointer; }
.attr-geomap-open:hover { color: #1a237e; }
.attr-geomap-badge-ext { display: inline-flex; align-items: center; gap: 4px; margin-left: 4px; font-weight: 500; }
/* содержимое бейджа приходит через v-html — scoped-стили только через :deep */
.attr-geomap-badge-ext :deep(.attr-geomap-badge-kv i) { font-style: normal; font-weight: 400; color: #6b7280; font-size: 11px; margin-right: 2px; }
.attr-geomap-badge-ext :deep(.attr-geomap-badge-state) { display: inline-block; padding: 0 5px; border-radius: 8px; font-size: 11px; font-weight: 600; line-height: 14px; }
.attr-geomap-badge-ext :deep(.attr-geomap-badge-unc) { display: inline-block; padding: 0 5px; border-radius: 8px; font-size: 11px; font-weight: 600; line-height: 14px; background: rgba(198, 40, 40, 0.16); color: #b71c1c; }
.attr-geomap-llabel { z-index: 4; pointer-events: auto; cursor: default; }
.attr-geomap-llabel-node { display: inline-flex; align-items: center; gap: 3px; }
.attr-geomap-llabel-node .attr-geomap-check { cursor: pointer; }
.attr-geomap-llabel-arrow { color: #6b7280; margin: 0 2px; }
.attr-geomap-legend {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    font-size: 12px;
    color: #374151;
}
/* IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): островки по нижним углам поверх карты (как кнопки-островки картографических сервисов) */
.attr-geomap-island {
    position: absolute;
    bottom: 8px;
    z-index: 6;
    background: rgba(255, 255, 255, 0.86);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(47, 59, 82, 0.18);
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.attr-geomap-island-legend { left: 8px; max-width: calc(100% - 140px); }
.attr-geomap-island-zoom { right: 8px; padding: 4px 6px; }
.attr-geomap-island .attr-geomap-zoom { margin-left: 0; }
.attr-geomap-legend-bar-single { border-color: rgba(47, 59, 82, 0.35); }
.attr-geomap-legend-title {
    font-weight: 600;
    margin-right: 4px;
}
.attr-geomap-legend-bar {
    display: inline-block;
    width: 160px;
    height: 10px;
    border-radius: 5px;
    border: 1px solid #2f3b52;
}
/* IE 2026 09 14 / ODOO-5800 (замечание Игоря): кнопки масштаба и «вписать» справа в нижней полосе */
.attr-geomap-zoom {
    margin-left: auto;
    display: inline-flex;
    gap: 4px;
}
.attr-geomap-zoombtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 20px;
    border: 1px solid #c9ced6;
    border-radius: 4px;
    background: #fff;
    color: #2f3b52;
    cursor: pointer;
    font-size: 11px;
}
.attr-geomap-zoombtn:hover { background: #eef1f5; }
.attr-geomap-host .wj-flexmap button.wj-btn { display: none; }   /* страховка: кнопки wijmo в углу карты */
</style>
<style>
/* IE 2026 09 14 / ODOO-5800: карта — контуры со скруглёнными стыками, подсветка территории под курсором */
.attr-geomap-host .wj-flexmap,
.attr-geomap-host .wj-flexchart {
    background: transparent;
    border: none;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
}
.attr-geomap-host svg path {
    stroke-linejoin: round;
    stroke-linecap: round;
    transition: fill-opacity 0.15s;
}
.attr-geomap-host svg path:hover {
    fill-opacity: 0.8;
}

/* IE 2026 09 15 / ODOO-… (замечание Игоря): муравьи по связям карты — холст поверх SVG-оверлея, мышь проходит сквозь */
.attr-geomap-ants { position: absolute; left: 0; top: 0; pointer-events: none; z-index: 5; }
.attr-geomap-ants-toggle { display: flex; gap: 6px; align-items: center; cursor: pointer; }
/* IE 2026 09 30 / ODOO-343341 (заказ Игоря: вкладки легенды карты на AttrTabPanel): вкладки [Node | Legend] окна легенды карты — AttrTabPanel (вид вкладок как у окна легенды графика и вкладок приложения) */
.attr-geomap-panel-wjtabs .attr-tab-panel { width: auto; min-width: 0; min-height: 0; }
.attr-geomap-panel-wjtabs .wj-tabpanel > div > .wj-tabheaders { position: static; padding: 0; border-bottom: 1px solid #eef0f3; }
.attr-geomap-panel-wjtabs .wj-tabpanel > div > .wj-tabpanes { padding-top: 4px; }
</style>
